//TODO: refactor - delete Enum

const Enum = {
  GENERAL_SEPARATOR: {
    r: "GENERAL_SEPARATOR",
    l: "Obecné",
    subhead: true,
    bold: true,
  },
  PUBLIC_HOME_SEARCH: {
    r: "PUBLIC_HOME_SEARCH",
    l: "Hlavní stránka - Hledat osobu",
  },
  HOUSE_NUMBER: { r: "HOUSE_NUMBER", l: "Číslo popisné / číslo orientační" },
  //ADD_REMOVE_STATEMENT: { r: 'ADD_REMOVE_STATEMENT', l: 'Přidat / odebrat oznámení' },
  ADD_REMOVE_WP: { r: "ADD_REMOVE_WP", l: "Přidat / odebrat funkci" },
  STATEMENT_TYPE: { r: "STATEMENT_TYPE", l: "Druh oznámení" },

  ADD_REMOVE_STATEMENT: {
    r: "ADD_REMOVE_STATEMENT",
    l: "Přidat / odebrat oznámení:",
    subhead: true,
  },
  ADD_REMOVE_ASSOCIATES: {
    r: "ADD_REMOVE_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  ADD_REMOVE_BUSSINESS: {
    r: "ADD_REMOVE_BUSSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  ADD_REMOVE_CP: {
    r: "ADD_REMOVE_CP",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  ADD_REMOVE_CS: { r: "ADD_REMOVE_CS", l: "Podíl v obchodní korporaci..." },
  ADD_REMOVE_CHATTELS: { r: "ADD_REMOVE_CHATTELS", l: "Jiné věci movité..." },
  ADD_REMOVE_INCOMES: {
    r: "ADD_REMOVE_INCOMES",
    l: "Jakékoliv peněžité příjmy...",
  },
  ADD_REMOVE_LIABILITIES: {
    r: "ADD_REMOVE_LIABILITIES",
    l: "Nesplacené závazky, zejména půjčky a úvěry...",
  },
  ADD_REMOVE_MEDIA: {
    r: "ADD_REMOVE_MEDIA",
    l: "Provozování rozhlasového nebo televizního vysílání...",
  },
  ADD_REMOVE_OM: {
    r: "ADD_REMOVE_OM",
    l: "Člen statutárního orgánu, člen řídícího...",
  },
  ADD_REMOVE_OC: {
    r: "ADD_REMOVE_OC",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu...",
  },
  ADD_REMOVE_REALTIES: { r: "ADD_REMOVE_REALTIES", l: "Věci nemovité" },

  REQUEST_SEPARATOR: {
    r: "REQUEST_SEPARATOR",
    l: "Žádost o nahlížení na neveřejné oznámení",
    subhead: true,
    bold: true,
  },
  REQUEST_ADRESS: { r: "REQUEST_ADRESS", l: "Adresa pro doručování" },
  REQUEST_TEXT: { r: "REQUEST_TEXT", l: "Obsah - Text" },

  INITIATIVE_SEPARATOR: {
    r: "INITIATIVE_SEPARATOR",
    l: "Podnět k prošetření",
    subhead: true,
    bold: true,
  },
  INITIATIVE_ADRESS: { r: "INITIATIVE_ADRESS", l: "Adresa pro doručování" },
  INITIATIVE_TEXT: { r: "INITIATIVE_TEXT", l: "Obsah - Text" },

  OVM: {
    r: "OVM",
    l: "Podpůrný (zapisující) orgán",
    subhead: true,
    bold: true,
  },
  OVM_BTN_ADD: { r: "OVM_BTN_ADD", l: "Přidat funkcionáře" },
  OVM_BTN_IMPORT: { r: "OVM_BTN_IMPORT", l: "Import csv ze souboru" },
  OVM_BTN_TEMPLATE: { r: "OVM_BTN_TEMPLATE", l: "Šablona xlsx ke stažení" },
  OVM_BTN_GENERATE: { r: "OVM_BTN_GENERATE", l: "Generovat jméno a heslo" },
  OVM_BTN_HANDOVER_PROTOCOL: { r: "OVM_BTN_HANDOVER_PROTOCOL", l: "Předávací protokol" },
  OVM_BIRTH_COUNTRY: { r: "OVM_BIRTH_COUNTRY", l: "Stát narození" },
  OVM_BIRTH_MUNICIPALITY: { r: "OVM_BIRTH_MUNICIPALITY", l: "Obec narození" },
  OVM_WP: { r: "OVM_WP", l: "Funkce" },
  OVM_ORG: { r: "OVM_ORG", l: "Organizace" },
  OVM_WP_START: { r: "OVM_WP_START", l: "Datum zahájení výkonu funkce" },
  OVM_WP_END: { r: "OVM_WP_END", l: "Datum ukončení výkonu funkce" },
  OVM_WP_FILL_START: {
    r: "OVM_WP_FILL_START",
    l: "Datum předání informace o zápisu zahájení výkonu funkce",
  },
  OVM_WP_FILL_END: {
    r: "OVM_WP_FILL_END",
    l: "Datum předání informace o zápisu ukončení výkonu funkce",
  },

  IN: { r: "IN", l: "Vstupní oznámení", subhead: true, bold: true },

  IN_INFO: {
    r: "IN_INFO",
    l: "Vstupní oznámení - Všeobecné údaje",
    subhead: true,
  },
  IN_BIRTH_COUNRTY: { r: "IN_BIRTH_COUNRTY", l: "Stát narození" },
  IN_BIRTH_MUNICIPALITY: { r: "IN_BIRTH_MUNICIPALITY", l: "Obec narození" },

  IN_ADDRESS: {
    r: "IN_ADDRESS",
    l: "Vstupní oznámení - Adresa pro doručování",
    subhead: true,
  },
  IN_EMAIL: { r: "IN_EMAIL", l: "E-mail" },

  IN_STATEMENT_TYPE_SEPARATOR: {
    r: "IN_STATEMENT_TYPE_SEPARATOR",
    l: "Vstupní  oznámení - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  IN_STATEMENT_TYPE: {
    r: "IN_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  IN_WP_DATE: { r: "IN_WP_DATE", l: "Datum zahájení výkonu funkce" },

  IN_CHATTEL_SEPARATOR: {
    r: "IN_CHATTEL_SEPARATOR",
    l: "Vstupní  oznámení - Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
    subhead: true,
  },
  IN_CHATTEL: {
    r: "IN_CHATTEL",
    l: "Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
  },
  IN_CHATTEL_ACQUISITION: { r: "IN_CHATTEL_ACQUISITION", l: "Způsob nabytí" },
  IN_CHATTEL_NOTE: { r: "IN_CHATTEL_NOTE", l: "Poznámka" },
  IN_CHATTEL_OWNERSHIP: { r: "IN_CHATTEL_OWNERSHIP", l: "Způsob vlastnictví" },
  IN_CHATTEL_PRICE: { r: "IN_CHATTEL_PRICE", l: "Cena obvyklá" },
  IN_CHATTEL_TYPE: { r: "IN_CHATTEL_TYPE", l: "Druh movité věci" },

  IN_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "IN_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Vstupní  oznámení - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
    subhead: true,
  },
  IN_COMMERCIAL_PAPERS: {
    r: "IN_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  IN_CP_ISSUER: { r: "IN_CP_ISSUER", l: "Emitent" },
  IN_CP_NOTE: { r: "IN_CP_NOTE", l: "Poznámka" },
  IN_CP_OWNERSHIP: { r: "IN_CP_OWNERSHIP", l: "Způsob vlastnictví" },
  IN_CP_TYPE: { r: "IN_CP_TYPE", l: "Druh " },

  IN_CORPORATION_SHARE_SEPARATOR: {
    r: "IN_CORPORATION_SHARE_SEPARATOR",
    l: "Vstupní  oznámení - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
    subhead: true,
  },
  IN_CORPORATION_SHARE: {
    r: "IN_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
  },
  IN_CS_ADDRESS: { r: "IN_CS_ADDRESS", l: "Sídlo obchodní korporace" },
  IN_CS_IDENTIFICATION_NUMBER: { r: "IN_CS_IDENTIFICATION_NUMBER", l: "IČO" },
  IN_CS_NAME: { r: "IN_CS_NAME", l: "Obchodní firma/název obchodní korporace" },
  IN_CS_NOTE: { r: "IN_CS_NOTE", l: "Poznámka" },
  IN_CS_OWNERSHIP: { r: "IN_CS_OWNERSHIP", l: "Způsob vlastnictví" },

  IN_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "IN_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Vstupní  oznámení - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  IN_LEGAL_BUSINESS_ASSOCIATES: {
    r: "IN_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  IN_LBA_ADDRESS: { r: "IN_LBA_ADDRESS", l: "Sídlo právnické osoby" },
  IN_LBA_IDENTIFICATION_NUMBER: { r: "IN_LBA_IDENTIFICATION_NUMBER", l: "IČO" },
  IN_LBA_NAME: { r: "IN_LBA_NAME", l: "Obchodní firma/název" },
  IN_LBA_NOTE: { r: "IN_LBA_NOTE", l: "Poznámka" },

  IN_LIABILITY_SEPARATOR: {
    r: "IN_LIABILITY_SEPARATOR",
    l: "Vstupní  oznámení - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
    subhead: true,
  },
  IN_LIABILITY: {
    r: "IN_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
  },
  IN_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "IN_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  IN_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "IN_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  IN_LIABILITY_LEGAL_PERSON_NAME: {
    r: "IN_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  IN_LIABILITY_NOTE: { r: "IN_LIABILITY_NOTE", l: "Poznámka" },
  IN_LIABILITY_PRICE: { r: "IN_LIABILITY_PRICE", l: "Výše závazku" },
  IN_LIABILITY_TYPE: { r: "IN_LIABILITY_TYPE", l: "Druh závazku" },

  IN_MEDIUM_SEPARATOR: {
    r: "IN_MEDIUM_SEPARATOR",
    l: "Vstupní  oznámení - Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
    subhead: true,
  },
  IN_MEDIUM: {
    r: "IN_MEDIUM",
    l: "Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
  },
  IN_MEDIUM_ADDRESS: { r: "IN_MEDIUM_ADDRESS", l: "Sídlo právnické osoby" },
  IN_MEDIUM_IDENTIFICATION_NUMBER: {
    r: "IN_MEDIUM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  IN_MEDIUM_LEGAL_PERSON_NAME: {
    r: "IN_MEDIUM_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název (provozovatele/vydavatele)",
  },
  IN_MEDIUM_NAME: { r: "IN_MEDIUM_NAME", l: "Název média" },
  IN_MEDIUM_NOTE: { r: "IN_MEDIUM_NOTE", l: "Poznámka" },

  IN_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "IN_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Vstupní  oznámení - Podnikání nebo provozování jiné samostatné výdělečné činnosti",
    subhead: true,
  },
  IN_NATURAL_PERSON_BUSINESS: {
    r: "IN_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  IN_NPB_METHOD: { r: "IN_NPB_METHOD", l: "Způsob" },
  IN_NPB_NOTE: { r: "IN_NPB_NOTE", l: "Poznámka" },
  IN_NPB_SUBJECT: { r: "IN_NPB_SUBJECT", l: "Předmět" },
  IN_NPB_PLACE: {
    r: "IN_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },

  IN_OTHER_CONTRACTS_SEPARATOR: {
    r: "IN_OTHER_CONTRACTS_SEPARATOR",
    l: "Vstupní  oznámení - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  IN_OTHER_CONTRACTS: {
    r: "IN_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  IN_OC_ADDRESS: {
    r: "IN_OC_ADDRESS",
    l: "Místo výkonu podnikání/sídlo právnické osoby",
  },
  IN_OC_FIRST_NAME: { r: "IN_OC_FIRST_NAME", l: "Jméno" },
  IN_OC_IDENTIFICATION_NUMBER: { r: "IN_OC_IDENTIFICATION_NUMBER", l: "IČO" },
  IN_OC_LAST_NAME: { r: "IN_OC_LAST_NAME", l: "Příjmení" },
  IN_OC_LEGAL_PERSON_NAME: { r: "IN_OC_LEGAL_PERSON_NAME", l: "Jméno/název" },
  IN_OC_NOTE: { r: "IN_OC_NOTE", l: "Poznámka" },
  IN_OC_SPECIFICATION: { r: "IN_OC_SPECIFICATION", l: "Specifikace" },
  IN_OC_TYPE: { r: "IN_OC_TYPE", l: "Druh činnosti" },

  IN_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "IN_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Vstupní  oznámení - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  IN_ORGANIZATION_MEMBER: {
    r: "IN_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  IN_OM_ADDRESS: { r: "IN_OM_ADDRESS", l: "Sídlo právnické osoby" },
  IN_OM_IDENTIFICATION_NUMBER: { r: "IN_OM_IDENTIFICATION_NUMBER", l: "IČO" },
  IN_OM_NAME: { r: "IN_OM_NAME", l: "Obchodní firma/název" },
  IN_OM_NOTE: { r: "IN_OM_NOTE", l: "Poznámka" },
  IN_OM_TYPE: { r: "IN_OM_TYPE", l: "Druh orgánu" },

  IN_REALTY_SEPARATOR: {
    r: "IN_REALTY_SEPARATOR",
    l: "Vstupní oznámení - Věci nemovité",
    subhead: true,
  },
  IN_REALTY: { r: "IN_REALTY", l: "Věci nemovité" },
  IN_REALTY_ACQUISITION: { r: "IN_REALTY_ACQUISITION", l: "Způsob nabytí" },
  IN_REALTY_IS_CADASTRE: {
    r: "IN_REALTY_IS_CADASTRE",
    l: "Import z katastru nemovitostí",
  },
  IN_REALTY_IS_NOT_CADASTRE: {
    r: "IN_REALTY_IS_NOT_CADASTRE",
    l: "Individuální zadání",
  },
  IN_REALTY_CADASTRE: {
    r: "IN_REALTY_CADASTRE",
    l: "Obec - katastrální území",
  },
  IN_REALTY_LV: { r: "IN_REALTY_LV", l: "Číslo LV" },
  IN_REALTY_NOTE: { r: "IN_REALTY_NOTE", l: "Poznámka" },
  IN_REALTY_ORIENTATION_NUMBER: {
    r: "IN_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },
  IN_REALTY_OWNERSHIP: { r: "IN_REALTY_OWNERSHIP", l: "Vlastnictví" },
  IN_REALTY_PARCEL_NUMBER: {
    r: "IN_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  IN_REALTY_TYPE: { r: "IN_REALTY_TYPE", l: "Druh nemovité věci" },
  IN_REALTY_HASFILEREF: {
    r: "IN_REALTY_HASFILEREF",
    l: "Oznámení o nemovitostech bylo podáno formou datového souboru",
  },
  IN_REALTY_PUBLICTEMPLATE: {
    r: "IN_REALTY_PUBLICTEMPLATE",
    l: "Stáhnout šablonu pro veřejnost",
  },
  IN_REALTY_PRIVATETEMPLATE: {
    r: "IN_REALTY_PRIVATETEMPLATE",
    l: "Stáhnout šablonu pro správce",
  },
  IN_REALTY_PUBLICFILE: {
    r: "IN_REALTY_PUBLICFILE",
    l: "Nahrát soubor pro veřejnost",
  },
  IN_REALTY_PRIVATEFILE: {
    r: "IN_REALTY_PRIVATEFILE",
    l: "Nahrát soubor pro správce",
  },
  IN_REALTY_PUBLICDATA: { r: "IN_REALTY_PUBLICDATA", l: "Data pro veřejnost" },
  IN_REALTY_PRIVATEDATA: { r: "IN_REALTY_PRIVATEDATA", l: "Data pro správce" },

  ON: { r: "ON", l: "Průběžné oznámení", subhead: true, bold: true },

  ON_INFO: {
    r: "ON_INFO",
    l: "Průběžné oznámení - Všeobecné údaje",
    subhead: true,
  },
  ON_BIRTH_COUNRTY: { r: "ON_BIRTH_COUNRTY", l: "Stát narození" },
  ON_BIRTH_MUNICIPALITY: { r: "ON_BIRTH_MUNICIPALITY", l: "Obec narození" },

  ON_ADDRESS: {
    r: "ON_ADDRESS",
    l: "Průběžné oznámení - Adresa pro doručování",
    subhead: true,
  },
  ON_EMAIL: { r: "ON_EMAIL", l: "Průběžné oznámení - E-mail" },

  ON_STATEMENT_TYPE_SEPARATOR: {
    r: "ON_STATEMENT_TYPE_SEPARATOR",
    l: "Průběžné oznámení - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  ON_STATEMENT_TYPE: {
    r: "ON_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  ON_FROM_DATE: { r: "ON_FROM_DATE", l: "Období od" },
  ON_TO_DATE: { r: "ON_TO_DATE", l: "Období do" },

  ON_CHATTEL_SEPARATOR: {
    r: "ON_CHATTEL_SEPARATOR",
    l: "Průběžné oznámení - Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
    subhead: true,
  },
  ON_CHATTEL: {
    r: "ON_CHATTEL",
    l: "Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
  },
  ON_CHATTEL_ACQUISITION: { r: "ON_CHATTEL_ACQUISITION", l: "Způsob nabytí" },
  ON_CHATTEL_NOTE: { r: "ON_CHATTEL_NOTE", l: "Poznámka" },
  ON_CHATTEL_OWNERSHIP: { r: "ON_CHATTEL_OWNERSHIP", l: "Způsob vlastnictví" },
  ON_CHATTEL_PRICE: { r: "ON_CHATTEL_PRICE", l: "Pořizovací cena" },
  ON_CHATTEL_TYPE: { r: "ON_CHATTEL_TYPE", l: "Druh movité věci" },

  ON_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "ON_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Průběžné oznámení - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
    subhead: true,
  },
  ON_COMMERCIAL_PAPERS: {
    r: "ON_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  ON_CP_ISSUER: { r: "ON_CP_ISSUER", l: "Emitent" },
  ON_CP_NOTE: { r: "ON_CP_NOTE", l: "Poznámka" },
  ON_CP_OWNERSHIP: { r: "ON_CP_OWNERSHIP", l: "Způsob vlastnictví" },
  ON_CP_PRICE: { r: "ON_CP_PRICE", l: "Pořizovací cena" },
  ON_CP_TYPE: { r: "ON_CP_TYPE", l: "Druh " },

  ON_CORPORATION_SHARE_SEPARATOR: {
    r: "ON_CORPORATION_SHARE_SEPARATOR",
    l: "Průběžné oznámení - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
    subhead: true,
  },
  ON_CORPORATION_SHARE: {
    r: "ON_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
  },
  ON_CS_ADDRESS: { r: "ON_CS_ADDRESS", l: "Sídlo obchodní korporace" },
  ON_CS_IDENTIFICATION_NUMBER: { r: "ON_CS_IDENTIFICATION_NUMBER", l: "IČO" },
  ON_CS_NAME: { r: "ON_CS_NAME", l: "Obchodní firma/název obchodní korporace" },
  ON_CS_NOTE: { r: "ON_CS_NOTE", l: "Poznámka" },

  ON_INCOME_SEPARATOR: {
    r: "ON_INCOME_SEPARATOR",
    l: "Průběžné oznámení - Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
    subhead: true,
  },
  ON_INCOME: {
    r: "ON_INCOME",
    l: "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
  },
  ON_INCOME_ADDRESS: { r: "ON_INCOME_ADDRESS", l: "Sídlo právnické osoby" },
  ON_INCOME_IDENTIFICATION_NUMBER: {
    r: "ON_INCOME_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  ON_INCOME_LEGAL_PERSON_NAME: {
    r: "ON_INCOME_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  ON_INCOME_NOTE: { r: "ON_INCOME_NOTE", l: "Poznámka" },
  ON_INCOME_PRICE: { r: "ON_INCOME_PRICE", l: "Výše příjmu" },
  ON_INCOME_PSC: { r: "ON_INCOME_PSC", l: "PSČ" },
  ON_INCOME_TYPE: { r: "ON_INCOME_TYPE", l: "Druh příjmu" },
  ON_INCOME_OTHER: { r: "ON_INCOME_OTHER", l: "Zdroj - jiný" },

  ON_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "ON_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Průběžné oznámení - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  ON_LEGAL_BUSINESS_ASSOCIATES: {
    r: "ON_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  ON_LBA_ADDRESS: { r: "ON_LBA_ADDRESS", l: "Sídlo právnické osoby" },
  ON_LBA_IDENTIFICATION_NUMBER: { r: "ON_LBA_IDENTIFICATION_NUMBER", l: "IČO" },
  ON_LBA_NAME: { r: "ON_LBA_NAME", l: "Obchodní firma/název" },
  ON_LBA_NOTE: { r: "ON_LBA_NOTE", l: "Poznámka" },

  ON_LIABILITY_SEPARATOR: {
    r: "ON_LIABILITY_SEPARATOR",
    l: "Průběžné oznámení - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
    subhead: true,
  },
  ON_LIABILITY: {
    r: "ON_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
  },
  ON_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "ON_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: " Sídlo právnické osoby",
  },
  ON_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "ON_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  ON_LIABILITY_LEGAL_PERSON_NAME: {
    r: "ON_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  ON_LIABILITY_NOTE: { r: "ON_LIABILITY_NOTE", l: "Poznámka" },
  ON_LIABILITY_PRICE: { r: "ON_LIABILITY_PRICE", l: "Výše závazku" },
  ON_LIABILITY_TYPE: { r: "ON_LIABILITY_TYPE", l: "Druh závazku" },

  ON_MEDIUM_SEPARATOR: {
    r: "ON_MEDIUM_SEPARATOR",
    l: "Průběžné  oznámení - Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
    subhead: true,
  },
  ON_MEDIUM: {
    r: "ON_MEDIUM",
    l: "Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
  },
  ON_MEDIUM_ADDRESS: { r: "ON_MEDIUM_ADDRESS", l: "Sídlo právnické osoby" },
  ON_MEDIUM_IDENTIFICATION_NUMBER: {
    r: "ON_MEDIUM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  ON_MEDIUM_LEGAL_PERSON_NAME: {
    r: "ON_MEDIUM_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název (provozovatele/vydavatele)",
  },
  ON_MEDIUM_NAME: { r: "ON_MEDIUM_NAME", l: "Název média" },
  ON_MEDIUM_NOTE: { r: "ON_MEDIUM_NOTE", l: "Poznámka" },

  ON_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "ON_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Průběžné oznámení - Podnikání nebo provozování jiné samostatné výdělečné výdělečné činnosti",
    subhead: true,
  },
  ON_NATURAL_PERSON_BUSINESS: {
    r: "ON_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  ON_NPB_METHOD: { r: "ON_NPB_METHOD", l: "Způsob" },
  ON_NPB_NOTE: { r: "ON_NPB_NOTE", l: "Poznámka" },
  ON_NPB_SUBJECT: { r: "ON_NPB_SUBJECT", l: "Předmět" },
  ON_NPB_PLACE: {
    r: "ON_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },

  ON_OTHER_CONTRACTS_SEPARATOR: {
    r: "ON_OTHER_CONTRACTS_SEPARATOR",
    l: "Průběžné oznámení - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  ON_OTHER_CONTRACTS: {
    r: "ON_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  ON_OC_ADDRESS: {
    r: "ON_OC_ADDRESS",
    l: "Místo výkonu podnikání/sídlo právnické osoby",
  },
  ON_OC_FIRST_NAME: { r: "ON_OC_FIRST_NAME", l: "Jméno" },
  ON_OC_IDENTIFICATION_NUMBER: { r: "ON_OC_IDENTIFICATION_NUMBER", l: "IČO" },
  ON_OC_LAST_NAME: { r: "ON_OC_LAST_NAME", l: "Příjmení" },
  ON_OC_LEGAL_PERSON_NAME: { r: "ON_OC_LEGAL_PERSON_NAME", l: "Jméno/název" },
  ON_OC_NOTE: { r: "ON_OC_NOTE", l: "Poznámka" },
  ON_OC_SPECIFICATION: { r: "ON_OC_SPECIFICATION", l: "Specifikace" },
  ON_OC_TYPE: { r: "ON_OC_TYPE", l: "Druh činnosti" },

  ON_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "ON_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Průběžné oznámení - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  ON_ORGANIZATION_MEMBER: {
    r: "ON_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  ON_OM_ADDRESS: { r: "ON_OM_ADDRESS", l: "Sídlo právnické osoby" },
  ON_OM_IDENTIFICATION_NUMBER: { r: "ON_OM_IDENTIFICATION_NUMBER", l: "IČO" },
  ON_OM_NAME: { r: "ON_OM_NAME", l: "Obchodní firma/název" },
  ON_OM_NOTE: { r: "ON_OM_NOTE", l: "Poznámka" },
  ON_OM_TYPE: { r: "ON_OM_TYPE", l: "Druh orgánu" },

  ON_REALTY_SEPARATOR: {
    r: "ON_REALTY_SEPARATOR",
    l: "Průběžné oznámení - Věci nemovité",
    subhead: true,
  },
  ON_REALTY: { r: "ON_REALTY", l: "Věci nemovité" },
  ON_REALTY_ACQUISITION: { r: "ON_REALTY_ACQUISITION", l: "Způsob nabytí" },
  ON_REALTY_IS_CADASTRE: {
    r: "ON_REALTY_IS_CADASTRE",
    l: "Import z katastru nemovitostí",
  },
  ON_REALTY_IS_NOT_CADASTRE: {
    r: "ON_REALTY_IS_NOT_CADASTRE",
    l: "Individuální zadání",
  },
  ON_REALTY_HASFILEREF: {
    r: "ON_REALTY_HASFILEREF",
    l: "Oznámení o nemovitostech bylo podáno formou datového souboru",
  },
  ON_REALTY_CADASTRE: {
    r: "ON_REALTY_CADASTRE",
    l: "katastrální území",
  },
  ON_REALTY_LV: { r: "ON_REALTY_LV", l: "Číslo LV" },
  ON_REALTY_NOTE: { r: "ON_REALTY_NOTE", l: "Poznámka" },
  ON_REALTY_ORIENTATION_NUMBER: {
    r: "ON_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },
  ON_REALTY_OWNERSHIP: { r: "ON_REALTY_OWNERSHIP", l: "Vlastnictví" },
  ON_REALTY_PARCEL_NUMBER: {
    r: "ON_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  ON_REALTY_PRICE: { r: "ON_REALTY_PRICE", l: "Pořizovací cena" },
  ON_REALTY_TYPE: { r: "ON_REALTY_TYPE", l: "Druh nemovité věci/Specifikace druhu" },
  ON_REALTY_PUBLICTEMPLATE: {
    r: "ON_REALTY_PUBLICTEMPLATE",
    l: "Stáhnout šablonu pro veřejnost",
  },
  ON_REALTY_PRIVATETEMPLATE: {
    r: "ON_REALTY_PRIVATETEMPLATE",
    l: "Stáhnout šablonu pro správce",
  },
  ON_REALTY_PUBLICFILE: {
    r: "ON_REALTY_PUBLICFILE",
    l: "Nahrát soubor pro veřejnost",
  },
  ON_REALTY_PRIVATEFILE: {
    r: "ON_REALTY_PRIVATEFILE",
    l: "Nahrát soubor pro správce",
  },
  ON_REALTY_PUBLICDATA: { r: "ON_REALTY_PUBLICDATA", l: "Data pro veřejnost" },
  ON_REALTY_PRIVATEDATA: { r: "ON_REALTY_PRIVATEDATA", l: "Data pro správce" },

  OUT: { r: "OUT", l: "Výstupní oznámení", subhead: true, bold: true },

  OUT_INFO: {
    r: "OUT_INFO",
    l: "Výstupní oznámení - Všeobecné údaje",
    subhead: true,
  },
  OUT_BIRTH_COUNRTY: { r: "OUT_BIRTH_COUNRTY", l: "Stát narození" },
  OUT_BIRTH_MUNICIPALITY: { r: "OUT_BIRTH_MUNICIPALITY", l: "Obec narození" },

  OUT_ADDRESS: {
    r: "OUT_ADDRESS",
    l: "Výstupní oznámení - Adresa pro doručování",
    subhead: true,
  },
  OUT_EMAIL: { r: "OUT_EMAIL", l: "E-mail" },

  OUT_STATEMENT_TYPE_SEPARATOR: {
    r: "OUT_STATEMENT_TYPE_SEPARATOR",
    l: "Výstupní oznámení - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  OUT_STATEMENT_TYPE: {
    r: "OUT_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  OUT_FROM_DATE: { r: "OUT_FROM_DATE", l: "Období od" },
  OUT_TO_DATE: { r: "OUT_TO_DATE", l: "Období do" },

  OUT_CHATTEL_SEPARATOR: {
    r: "OUT_CHATTEL_SEPARATOR",
    l: "Výstupní oznámení - Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
    subhead: true,
  },
  OUT_CHATTEL: {
    r: "OUT_CHATTEL",
    l: "Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
  },
  OUT_CHATTEL_ACQUISITION: { r: "OUT_CHATTEL_ACQUISITION", l: "Způsob nabytí" },
  OUT_CHATTEL_NOTE: { r: "OUT_CHATTEL_NOTE", l: "Poznámka" },
  OUT_CHATTEL_OWNERSHIP: {
    r: "OUT_CHATTEL_OWNERSHIP",
    l: "Způsob vlastnictví",
  },
  OUT_CHATTEL_PRICE: { r: "OUT_CHATTEL_PRICE", l: "Pořizovací cena" },
  OUT_CHATTEL_TYPE: { r: "OUT_CHATTEL_TYPE", l: "Druh movité věci" },

  OUT_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "OUT_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Výstupní oznámení - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
    subhead: true,
  },
  OUT_COMMERCIAL_PAPERS: {
    r: "OUT_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  OUT_CP_ISSUER: { r: "OUT_CP_ISSUER", l: "Emitent" },
  OUT_CP_NOTE: { r: "OUT_CP_NOTE", l: "Poznámka" },
  OUT_CP_OWNERSHIP: { r: "OUT_CP_OWNERSHIP", l: "Způsob vlastnictví" },
  OUT_CP_PRICE: { r: "OUT_CP_PRICE", l: "Pořizovací cena" },
  OUT_CP_TYPE: { r: "OUT_CP_TYPE", l: "Druh " },

  OUT_CORPORATION_SHARE_SEPARATOR: {
    r: "OUT_CORPORATION_SHARE_SEPARATOR",
    l: "Výstupní oznámení - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
    subhead: true,
  },
  OUT_CORPORATION_SHARE: {
    r: "OUT_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
  },
  OUT_CS_ADDRESS: { r: "OUT_CS_ADDRESS", l: "Sídlo obchodní korporace" },
  OUT_CS_IDENTIFICATION_NUMBER: { r: "OUT_CS_IDENTIFICATION_NUMBER", l: "IČO" },
  OUT_CS_NAME: {
    r: "OUT_CS_NAME",
    l: "Obchodní firma/název obchodní korporace",
  },
  OUT_CS_NOTE: { r: "OUT_CS_NOTE", l: "Poznámka" },
  OUT_CS_OWNERSHIP: { r: "OUT_CS_OWNERSHIP", l: "Způsob vlastnictví" },

  OUT_INCOME_SEPARATOR: {
    r: "OUT_INCOME_SEPARATOR",
    l: "Výstupní oznámení - Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhla ke dni ukončení výkonu funkce částku 100 000,- Kč",
    subhead: true,
  },
  OUT_INCOME: {
    r: "OUT_INCOME",
    l: "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhla ke dni ukončení výkonu funkce částku 100 000,- Kč",
  },
  OUT_INCOME_ADDRESS: { r: "OUT_INCOME_ADDRESS", l: "Sídlo právnické osoby" },
  OUT_INCOME_IDENTIFICATION_NUMBER: {
    r: "OUT_INCOME_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OUT_INCOME_LEGAL_PERSON_NAME: {
    r: "OUT_INCOME_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OUT_INCOME_NOTE: { r: "OUT_INCOME_NOTE", l: "Poznámka" },
  OUT_INCOME_PRICE: { r: "OUT_INCOME_PRICE", l: "Výše příjmu" },
  OUT_INCOME_PSC: { r: "OUT_INCOME_PSC", l: "PSČ" },
  OUT_INCOME_TYPE: { r: "OUT_INCOME_TYPE", l: "Druh příjmu" },
  OUT_INCOME_OTHER: { r: "OUT_INCOME_OTHER", l: "Zdroj - jiný" },

  OUT_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "OUT_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Výstupní oznámení - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  OUT_LEGAL_BUSINESS_ASSOCIATES: {
    r: "OUT_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  OUT_LBA_ADDRESS: { r: "OUT_LBA_ADDRESS", l: "Sídlo právnické osoby" },
  OUT_LBA_IDENTIFICATION_NUMBER: {
    r: "OUT_LBA_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OUT_LBA_NAME: { r: "OUT_LBA_NAME", l: "Obchodní firma/název" },
  OUT_LBA_NOTE: { r: "OUT_LBA_NOTE", l: "Poznámka" },

  OUT_LIABILITY_SEPARATOR: {
    r: "OUT_LIABILITY_SEPARATOR",
    l: "Výstupní oznámení - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
    subhead: true,
  },
  OUT_LIABILITY: {
    r: "OUT_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
  },
  OUT_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "OUT_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  OUT_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "OUT_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OUT_LIABILITY_LEGAL_PERSON_NAME: {
    r: "OUT_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OUT_LIABILITY_NOTE: { r: "OUT_LIABILITY_NOTE", l: "Poznámka" },
  OUT_LIABILITY_PRICE: { r: "OUT_LIABILITY_PRICE", l: "Výše závazku" },
  OUT_LIABILITY_TYPE: { r: "OUT_LIABILITY_TYPE", l: "Druh závazku" },

  OUT_MEDIUM_SEPARATOR: {
    r: "OUT_MEDIUM_SEPARATOR",
    l: "Výstupní  oznámení - Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
    subhead: true,
  },
  OUT_MEDIUM: {
    r: "OUT_MEDIUM",
    l: "Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
  },
  OUT_MEDIUM_ADDRESS: { r: "OUT_MEDIUM_ADDRESS", l: "Sídlo právnické osoby" },
  OUT_MEDIUM_IDENTIFICATION_NUMBER: {
    r: "OUT_MEDIUM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OUT_MEDIUM_LEGAL_PERSON_NAME: {
    r: "OUT_MEDIUM_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název (provozovatele/vydavatele)",
  },
  OUT_MEDIUM_NAME: { r: "OUT_MEDIUM_NAME", l: "Název média" },
  OUT_MEDIUM_NOTE: { r: "OUT_MEDIUM_NOTE", l: "Poznámka" },

  OUT_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "OUT_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Výstupní oznámení - Podnikání nebo provozování jiné samostatné výdělečné činnosti",
    subhead: true,
  },
  OUT_NATURAL_PERSON_BUSINESS: {
    r: "OUT_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  OUT_NPB_METHOD: { r: "OUT_NPB_METHOD", l: "Způsob" },
  OUT_NPB_NOTE: { r: "OUT_NPB_NOTE", l: "Poznámka" },
  OUT_NPB_SUBJECT: { r: "OUT_NPB_SUBJECT", l: "Předmět" },
  OUT_NPB_PLACE: {
    r: "OUT_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },

  OUT_OTHER_CONTRACTS_SEPARATOR: {
    r: "OUT_OTHER_CONTRACTS_SEPARATOR",
    l: "Výstupní oznámení - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  OUT_OTHER_CONTRACTS: {
    r: "OUT_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  OUT_OC_ADDRESS: {
    r: "OUT_OC_ADDRESS",
    l: "Místo výkonu podnikání/sídlo právnické osoby",
  },
  OUT_OC_FIRST_NAME: { r: "OUT_OC_FIRST_NAME", l: "Jméno" },
  OUT_OC_IDENTIFICATION_NUMBER: { r: "OUT_OC_IDENTIFICATION_NUMBER", l: "IČO" },
  OUT_OC_LAST_NAME: { r: "OUT_OC_LAST_NAME", l: "Příjmení" },
  OUT_OC_LEGAL_PERSON_NAME: { r: "OUT_OC_LEGAL_PERSON_NAME", l: "Jméno/název" },
  OUT_OC_NOTE: { r: "OUT_OC_NOTE", l: "Poznámka" },
  OUT_OC_SPECIFICATION: { r: "OUT_OC_SPECIFICATION", l: "Specifikace" },
  OUT_OC_TYPE: { r: "OUT_OC_TYPE", l: "Druh činnosti" },

  OUT_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "OUT_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Výstupní oznámení - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  OUT_ORGANIZATION_MEMBER: {
    r: "OUT_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  OUT_OM_ADDRESS: { r: "OUT_OM_ADDRESS", l: "Sídlo právnické osoby" },
  OUT_OM_IDENTIFICATION_NUMBER: { r: "OUT_OM_IDENTIFICATION_NUMBER", l: "IČO" },
  OUT_OM_NAME: { r: "OUT_OM_NAME", l: "Obchodní firma/název" },
  OUT_OM_NOTE: { r: "OUT_OM_NOTE", l: "Poznámka" },
  OUT_OM_TYPE: { r: "OUT_OM_TYPE", l: "Druh orgánu" },

  OUT_REALTY_SEPARATOR: {
    r: "OUT_REALTY_SEPARATOR",
    l: "Výstupní oznámení - Věci nemovité",
    subhead: true,
  },
  OUT_REALTY: { r: "OUT_REALTY", l: "Věci nemovité" },
  OUT_REALTY_ACQUISITION: { r: "OUT_REALTY_ACQUISITION", l: "Způsob nabytí" },
  OUT_REALTY_IS_CADASTRE: {
    r: "OUT_REALTY_IS_CADASTRE",
    l: "Import z katastru nemovitostí",
  },
  OUT_REALTY_IS_NOT_CADASTRE: {
    r: "OUT_REALTY_IS_NOT_CADASTRE",
    l: "Individuální zadání",
  },
  OUT_REALTY_CADASTRE: {
    r: "OUT_REALTY_CADASTRE",
    l: "Obec - katastrální území",
  },
  OUT_REALTY_LV: { r: "OUT_REALTY_LV", l: "Číslo LV" },
  OUT_REALTY_NOTE: { r: "OUT_REALTY_NOTE", l: "Poznámka" },
  OUT_REALTY_ORIENTATION_NUMBER: {
    r: "OUT_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },
  OUT_REALTY_OWNERSHIP: { r: "OUT_REALTY_OWNERSHIP", l: "Vlastnictví" },
  OUT_REALTY_PARCEL_NUMBER: {
    r: "OUT_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  OUT_REALTY_PRICE: { r: "OUT_REALTY_PRICE", l: "Pořizovací cena" },
  OUT_REALTY_TYPE: { r: "OUT_REALTY_TYPE", l: "Druh nemovité věci" },
  OUT_REALTY_HASFILEREF: {
    r: "OUT_REALTY_HASFILEREF",
    l: "Oznámení o nemovitostech bylo podáno formou datového souboru",
  },
  OUT_REALTY_PUBLICTEMPLATE: {
    r: "OUT_REALTY_PUBLICTEMPLATE",
    l: "Stáhnout šablonu pro veřejnost",
  },
  OUT_REALTY_PRIVATETEMPLATE: {
    r: "OUT_REALTY_PRIVATETEMPLATE",
    l: "Stáhnout šablonu pro správce",
  },
  OUT_REALTY_PUBLICFILE: {
    r: "OUT_REALTY_PUBLICFILE",
    l: "Nahrát soubor pro veřejnost",
  },
  OUT_REALTY_PRIVATEFILE: {
    r: "OUT_REALTY_PRIVATEFILE",
    l: "Nahrát soubor pro správce",
  },
  OUT_REALTY_PUBLICDATA: {
    r: "OUT_REALTY_PUBLICDATA",
    l: "Data pro veřejnost",
  },
  OUT_REALTY_PRIVATEDATA: {
    r: "OUT_REALTY_PRIVATEDATA",
    l: "Data pro správce",
  },

  POINT3: {
    r: "POINT3",
    l: "Oznámení podle Čl. II bodu 3",
    subhead: true,
    bold: true,
  },

  POINT3_INFO: {
    r: "POINT3_INFO",
    l: "Oznámení podle Čl. II bodu 3 - Všeobecné údaje",
    subhead: true,
  },
  POINT3_BIRTH_COUNRTY: { r: "POINT3_BIRTH_COUNRTY", l: "Stát narození" },
  POINT3_BIRTH_MUNICIPALITY: {
    r: "POINT3_BIRTH_MUNICIPALITY",
    l: "Obec narození",
  },

  POINT3_ADDRESS: {
    r: "POINT3_ADDRESS",
    l: "Oznámení podle Čl. II bodu 3 - Adresa pro doručování",
    subhead: true,
  },
  POINT3_EMAIL: { r: "POINT3_EMAIL", l: "E-mail" },

  POINT3_STATEMENT_TYPE_SEPARATOR: {
    r: "POINT3_STATEMENT_TYPE_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  POINT3_STATEMENT_TYPE: {
    r: "POINT3_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },

  POINT3_CHATTEL_SEPARATOR: {
    r: "POINT3_CHATTEL_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
    subhead: true,
  },
  POINT3_CHATTEL: {
    r: "POINT3_CHATTEL",
    l: "Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
  },
  POINT3_CHATTEL_ACQUISITION: {
    r: "POINT3_CHATTEL_ACQUISITION",
    l: "Způsob nabytí",
  },
  POINT3_CHATTEL_NOTE: { r: "POINT3_CHATTEL_NOTE", l: "Poznámka" },
  POINT3_CHATTEL_OWNERSHIP: {
    r: "POINT3_CHATTEL_OWNERSHIP",
    l: "Způsob vlastnictví",
  },
  POINT3_CHATTEL_PRICE: { r: "POINT3_CHATTEL_PRICE", l: "Pořizovací cena" },
  POINT3_CHATTEL_TYPE: { r: "POINT3_CHATTEL_TYPE", l: "Druh movité věci" },

  POINT3_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "POINT3_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
    subhead: true,
  },
  POINT3_COMMERCIAL_PAPERS: {
    r: "POINT3_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  POINT3_CP_ISSUER: { r: "POINT3_CP_ISSUER", l: "Emitent" },
  POINT3_CP_NOTE: { r: "POINT3_CP_NOTE", l: "Poznámka" },
  POINT3_CP_OWNERSHIP: { r: "POINT3_CP_OWNERSHIP", l: "Způsob vlastnictví" },
  POINT3_CP_PRICE: { r: "POINT3_CP_PRICE", l: "Pořizovací cena" },
  POINT3_CP_TYPE: { r: "POINT3_CP_TYPE", l: "Druh " },

  POINT3_CORPORATION_SHARE_SEPARATOR: {
    r: "POINT3_CORPORATION_SHARE_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
    subhead: true,
  },
  POINT3_CORPORATION_SHARE: {
    r: "POINT3_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
  },
  POINT3_CS_ADDRESS: { r: "POINT3_CS_ADDRESS", l: "Sídlo obchodní korporace" },
  POINT3_CS_IDENTIFICATION_NUMBER: {
    r: "POINT3_CS_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_CS_NAME: {
    r: "POINT3_CS_NAME",
    l: "Obchodní firma/název obchodní korporace",
  },
  POINT3_CS_NOTE: { r: "POINT3_CS_NOTE", l: "Poznámka" },

  POINT3_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "POINT3_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  POINT3_LEGAL_BUSINESS_ASSOCIATES: {
    r: "POINT3_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  POINT3_LBA_ADDRESS: { r: "POINT3_LBA_ADDRESS", l: "Sídlo právnické osoby" },
  POINT3_LBA_IDENTIFICATION_NUMBER: {
    r: "POINT3_LBA_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_LBA_NAME: { r: "POINT3_LBA_NAME", l: "Obchodní firma/název" },
  POINT3_LBA_NOTE: { r: "POINT3_LBA_NOTE", l: "Poznámka" },

  POINT3_LIABILITY_SEPARATOR: {
    r: "POINT3_LIABILITY_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
    subhead: true,
  },
  POINT3_LIABILITY: {
    r: "POINT3_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
  },
  POINT3_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "POINT3_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  POINT3_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "POINT3_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_LIABILITY_LEGAL_PERSON_NAME: {
    r: "POINT3_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  POINT3_LIABILITY_NOTE: { r: "POINT3_LIABILITY_NOTE", l: "Poznámka" },
  POINT3_LIABILITY_PRICE: { r: "POINT3_LIABILITY_PRICE", l: "Výše závazku" },
  POINT3_LIABILITY_TYPE: { r: "POINT3_LIABILITY_TYPE", l: "Druh závazku" },

  POINT3_MEDIUM_SEPARATOR: {
    r: "POINT3_MEDIUM_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
    subhead: true,
  },
  POINT3_MEDIUM: {
    r: "POINT3_MEDIUM",
    l: "Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
  },
  POINT3_MEDIUM_ADDRESS: {
    r: "POINT3_MEDIUM_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  POINT3_MEDIUM_IDENTIFICATION_NUMBER: {
    r: "POINT3_MEDIUM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_MEDIUM_LEGAL_PERSON_NAME: {
    r: "POINT3_MEDIUM_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název (provozovatele/vydavatele)",
  },
  POINT3_MEDIUM_NAME: { r: "POINT3_MEDIUM_NAME", l: "Název média" },
  POINT3_MEDIUM_NOTE: { r: "POINT3_MEDIUM_NOTE", l: "Poznámka" },

  POINT3_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "POINT3_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Podnikání nebo provozování jiné samostatné výdělečné činnosti",
    subhead: true,
  },
  POINT3_NATURAL_PERSON_BUSINESS: {
    r: "POINT3_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  POINT3_NPB_METHOD: { r: "POINT3_NPB_METHOD", l: "Způsob" },
  POINT3_NPB_NOTE: { r: "POINT3_NPB_NOTE", l: "Poznámka" },
  POINT3_NPB_SUBJECT: { r: "POINT3_NPB_SUBJECT", l: "Předmět" },
  POINT3_NPB_PLACE: {
    r: "POINT3_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },

  POINT3_OTHER_CONTRACTS_SEPARATOR: {
    r: "POINT3_OTHER_CONTRACTS_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  POINT3_OTHER_CONTRACTS: {
    r: "POINT3_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  POINT3_OC_ADDRESS: {
    r: "POINT3_OC_ADDRESS",
    l: "Místo výkonu podnikání/sídlo právnické osoby",
  },
  POINT3_OC_FIRST_NAME: { r: "POINT3_OC_FIRST_NAME", l: "Jméno" },
  POINT3_OC_IDENTIFICATION_NUMBER: {
    r: "POINT3_OC_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_OC_LAST_NAME: { r: "POINT3_OC_LAST_NAME", l: "Příjmení" },
  POINT3_OC_LEGAL_PERSON_NAME: {
    r: "POINT3_OC_LEGAL_PERSON_NAME",
    l: "Jméno/název",
  },
  POINT3_OC_NOTE: { r: "POINT3_OC_NOTE", l: "Poznámka" },
  POINT3_OC_SPECIFICATION: { r: "POINT3_OC_SPECIFICATION", l: "Specifikace" },
  POINT3_OC_TYPE: { r: "POINT3_OC_TYPE", l: "Druh činnosti" },

  POINT3_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "POINT3_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  POINT3_ORGANIZATION_MEMBER: {
    r: "POINT3_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  POINT3_OM_ADDRESS: { r: "POINT3_OM_ADDRESS", l: "Sídlo právnické osoby" },
  POINT3_OM_IDENTIFICATION_NUMBER: {
    r: "POINT3_OM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_OM_NAME: { r: "POINT3_OM_NAME", l: "Obchodní firma/název" },
  POINT3_OM_NOTE: { r: "POINT3_OM_NOTE", l: "Poznámka" },
  POINT3_OM_TYPE: { r: "POINT3_OM_TYPE", l: "Druh orgánu" },

  POINT3_REALTY_SEPARATOR: {
    r: "POINT3_REALTY_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Věci nemovité",
    subhead: true,
  },
  POINT3_REALTY: { r: "POINT3_REALTY", l: "Věci nemovité" },
  POINT3_REALTY_ACQUISITION: {
    r: "POINT3_REALTY_ACQUISITION",
    l: "Způsob nabytí",
  },
  POINT3_REALTY_CADASTRE: {
    r: "POINT3_REALTY_CADASTRE",
    l: "katastrální území",
  },
  POINT3_REALTY_LV: { r: "POINT3_REALTY_LV", l: "Číslo LV" },
  POINT3_REALTY_NOTE: { r: "POINT3_REALTY_NOTE", l: "Poznámka" },
  POINT3_REALTY_ORIENTATION_NUMBER: {
    r: "POINT3_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },
  POINT3_REALTY_OWNERSHIP: { r: "POINT3_REALTY_OWNERSHIP", l: "Vlastnictví" },
  POINT3_REALTY_PARCEL_NUMBER: {
    r: "POINT3_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  POINT3_REALTY_PRICE: { r: "POINT3_REALTY_PRICE", l: "Pořizovací cena" },
  POINT3_REALTY_TYPE: { r: "POINT3_REALTY_TYPE", l: "Druh nemovité věci" },
  POINT3_REALTY_HASFILEREF: {
    r: "POINT3_REALTY_HASFILEREF",
    l: "Oznámení o nemovitostech bylo podáno formou datového souboru",
  },
  POINT3_REALTY_PUBLICTEMPLATE: {
    r: "POINT3_REALTY_PUBLICTEMPLATE",
    l: "Stáhnout šablonu pro veřejnost",
  },
  POINT3_REALTY_PRIVATETEMPLATE: {
    r: "POINT3_REALTY_PRIVATETEMPLATE",
    l: "Stáhnout šablonu pro správce",
  },
  POINT3_REALTY_PUBLICFILE: {
    r: "POINT3_REALTY_PUBLICFILE",
    l: "Nahrát soubor pro veřejnost",
  },
  POINT3_REALTY_PRIVATEFILE: {
    r: "POINT3_REALTY_PRIVATEFILE",
    l: "Nahrát soubor pro správce",
  },
  POINT3_REALTY_PUBLICDATA: {
    r: "POINT3_REALTY_PUBLICDATA",
    l: "Data pro veřejnost",
  },
  POINT3_REALTY_PRIVATEDATA: {
    r: "POINT3_REALTY_PRIVATEDATA",
    l: "Data pro správce",
  },

  POINT4: {
    r: "POINT4",
    l: "Oznámení podle Čl. II bodu 4",
    subhead: true,
    bold: true,
  },

  POINT4_INFO: {
    r: "POINT4_INFO",
    l: "Oznámení podle Čl. II bodu 4 - Všeobecné údaje",
    subhead: true,
  },
  POINT4_BIRTH_COUNRTY: { r: "POINT4_BIRTH_COUNRTY", l: "Stát narození" },
  POINT4_BIRTH_MUNICIPALITY: {
    r: "POINT4_BIRTH_MUNICIPALITY",
    l: "Obec narození",
  },

  POINT4_ADDRESS: {
    r: "POINT4_ADDRESS",
    l: "Oznámení podle Čl. II bodu 4 - Adresa pro doručování",
    subhead: true,
  },
  POINT4_EMAIL: { r: "POINT4_EMAIL", l: "E-mail" },

  POINT4_STATEMENT_TYPE_SEPARATOR: {
    r: "POINT4_STATEMENT_TYPE_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 4 - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  POINT4_STATEMENT_TYPE: {
    r: "POINT4_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  POINT4_FROM_DATE: { r: "POINT4_FROM_DATE", l: "Období od" },
  POINT4_TO_DATE: { r: "POINT4_TO_DATE", l: "Období do" },

  POINT4_INCOME_SEPARATOR: {
    r: "POINT4_INCOME_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 4 - Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
    subhead: true,
  },
  POINT4_INCOME: {
    r: "POINT4_INCOME",
    l: "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
  },
  POINT4_INCOME_ADDRESS: {
    r: "POINT4_INCOME_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  POINT4_INCOME_IDENTIFICATION_NUMBER: {
    r: "POINT4_INCOME_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT4_INCOME_LEGAL_PERSON_NAME: {
    r: "POINT4_INCOME_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  POINT4_INCOME_NOTE: { r: "POINT4_INCOME_NOTE", l: "Poznámka" },
  POINT4_INCOME_TYPE: { r: "POINT4_INCOME_TYPE", l: "Druh příjmu" },
  POINT4_INCOME_PRICE: { r: "POINT4_INCOME_PRICE", l: "Výše příjmu" },
  POINT4_INCOME_OTHER: { r: "POINT4_INCOME_OTHER", l: "Zdroj - jiný" },

  OFFICIAL: {
    r: "OFFICIAL",
    l: "Oznámení pro poslance a senátory, kteří složili slib do 31.8.2017 včetně",
    subhead: true,
    bold: true,
  },

  OFFICIAL_INFO: {
    r: "OFFICIAL_INFO",
    l: "Oznámení pro poslance a senátory - Všeobecné údaje",
    subhead: true,
  },
  OFFICIAL_BIRTH_COUNRTY: { r: "OFFICIAL_BIRTH_COUNRTY", l: "Stát narození" },
  OFFICIAL_BIRTH_MUNICIPALITY: {
    r: "OFFICIAL_BIRTH_MUNICIPALITY",
    l: "Obec narození",
  },

  OFFICIAL_ADDRESS: {
    r: "OFFICIAL_ADDRESS",
    l: "Oznámení pro poslance a senátory - Adresa pro doručování",
    subhead: true,
  },
  OFFICIAL_EMAIL: { r: "OFFICIAL_EMAIL", l: "E-mail" },

  OFFICIAL_STATEMENT_TYPE_SEPARATOR: {
    r: "OFFICIAL_STATEMENT_TYPE_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  OFFICIAL_STATEMENT_TYPE: {
    r: "OFFICIAL_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  OFFICIAL_FROM_DATE: { r: "OFFICIAL_FROM_DATE", l: "Období od" },
  OFFICIAL_TO_DATE: { r: "OFFICIAL_TO_DATE", l: "Období do" },

  OFFICIAL_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "OFFICIAL_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Podnikání nebo provozování jiné samostatné výdělečné činnosti",
    subhead: true,
  },
  OFFICIAL_NATURAL_PERSON_BUSINESS: {
    r: "OFFICIAL_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  OFFICIAL_NPB_METHOD: { r: "OFFICIAL_NPB_METHOD", l: "Způsob" },
  OFFICIAL_NPB_NOTE: { r: "OFFICIAL_NPB_NOTE", l: "Poznámka" },
  OFFICIAL_NPB_SUBJECT: { r: "OFFICIAL_NPB_SUBJECT", l: "Předmět" },
  OFFICIAL_NPB_PLACE: {
    r: "OFFICIAL_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },

  OFFICIAL_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "OFFICIAL_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  OFFICIAL_LEGAL_BUSINESS_ASSOCIATES: {
    r: "OFFICIAL_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  OFFICIAL_LBA_ADDRESS: {
    r: "OFFICIAL_LBA_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  OFFICIAL_LBA_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_LBA_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_LBA_NAME: { r: "OFFICIAL_LBA_NAME", l: "Obchodní firma/název" },
  OFFICIAL_LBA_NOTE: { r: "OFFICIAL_LBA_NOTE", l: "Poznámka" },

  OFFICIAL_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "OFFICIAL_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  OFFICIAL_ORGANIZATION_MEMBER: {
    r: "OFFICIAL_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  OFFICIAL_OM_ADDRESS: { r: "OFFICIAL_OM_ADDRESS", l: "Sídlo právnické osoby" },
  OFFICIAL_OM_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_OM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_OM_NAME: { r: "OFFICIAL_OM_NAME", l: "Obchodní firma/název" },
  OFFICIAL_OM_NOTE: { r: "OFFICIAL_OM_NOTE", l: "Poznámka" },
  OFFICIAL_OM_TYPE: { r: "OFFICIAL_OM_TYPE", l: "Druh orgánu" },

  OFFICIAL_OTHER_CONTRACTS_SEPARATOR: {
    r: "OFFICIAL_OTHER_CONTRACTS_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  OFFICIAL_OTHER_CONTRACTS: {
    r: "OFFICIAL_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  OFFICIAL_OC_ADDRESS: { r: "OFFICIAL_OC_ADDRESS", l: "Sídlo právnické osoby" },
  OFFICIAL_OC_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_OC_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_OC_LEGAL_PERSON_NAME: {
    r: "OFFICIAL_OC_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OFFICIAL_OC_NOTE: { r: "OFFICIAL_OC_NOTE", l: "Poznámka" },
  OFFICIAL_OC_TYPE: { r: "OFFICIAL_OC_TYPE", l: "Druh činnosti" },

  OFFICIAL_REALTY_SEPARATOR: {
    r: "OFFICIAL_REALTY_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Věci nemovité",
    subhead: true,
  },
  OFFICIAL_REALTY: { r: "OFFICIAL_REALTY", l: "Věci nemovité" },
  OFFICIAL_REALTY_ACQUISITION: {
    r: "OFFICIAL_REALTY_ACQUISITION",
    l: "Způsob nabytí",
  },
  OFFICIAL_REALTY_CADASTRE: {
    r: "OFFICIAL_REALTY_CADASTRE",
    l: "Obec - katastrální území",
  },
  OFFICIAL_REALTY_LV: { r: "OFFICIAL_REALTY_LV", l: "Číslo LV" },
  OFFICIAL_REALTY_NOTE: { r: "OFFICIAL_REALTY_NOTE", l: "Poznámka" },
  OFFICIAL_REALTY_ORIENTATION_NUMBER: {
    r: "OFFICIAL_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },
  OFFICIAL_REALTY_OWNERSHIP: {
    r: "OFFICIAL_REALTY_OWNERSHIP",
    l: "Vlastnictví",
  },
  OFFICIAL_REALTY_PARCEL_NUMBER: {
    r: "OFFICIAL_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  OFFICIAL_REALTY_PRICE: { r: "OFFICIAL_REALTY_PRICE", l: "Pořizovací cena" },
  OFFICIAL_REALTY_TYPE: { r: "OFFICIAL_REALTY_TYPE", l: "Druh nemovité věci" },
  OFFICIAL_REALTY_HASFILEREF: {
    r: "OFFICIAL_REALTY_HASFILEREF",
    l: "Oznámení o nemovitostech bylo podáno formou datového souboru",
  },
  OFFICIAL_REALTY_PUBLICTEMPLATE: {
    r: "OFFICIAL_REALTY_PUBLICTEMPLATE",
    l: "Stáhnout šablonu pro veřejnost",
  },
  OFFICIAL_REALTY_PRIVATETEMPLATE: {
    r: "OFFICIAL_REALTY_PRIVATETEMPLATE",
    l: "Stáhnout šablonu pro správce",
  },
  OFFICIAL_REALTY_PUBLICFILE: {
    r: "OFFICIAL_REALTY_PUBLICFILE",
    l: "Nahrát soubor pro veřejnost",
  },
  OFFICIAL_REALTY_PRIVATEFILE: {
    r: "OFFICIAL_REALTY_PRIVATEFILE",
    l: "Nahrát soubor pro správce",
  },
  OFFICIAL_REALTY_PUBLICDATA: {
    r: "OFFICIAL_REALTY_PUBLICDATA",
    l: "Data pro veřejnost",
  },
  OFFICIAL_REALTY_PRIVATEDATA: {
    r: "OFFICIAL_REALTY_PRIVATEDATA",
    l: "Data pro správce",
  },

  OFFICIAL_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "OFFICIAL_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená...",
    subhead: true,
  },
  OFFICIAL_COMMERCIAL_PAPERS: {
    r: "OFFICIAL_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená, pokud celková výše kupní ceny cenných papírů, zaknihovaných cenných papírů nebo práv s nimi spojených od jednoho emitenta v době nabytí přesahuje částku 50 000,- Kč anebo částku 100 000,- Kč v případě více emitentů",
  },
  OFFICIAL_CP_ISSUER: { r: "OFFICIAL_CP_ISSUER", l: "Emitent" },
  OFFICIAL_CP_NOTE: { r: "OFFICIAL_CP_NOTE", l: "Poznámka" },
  OFFICIAL_CP_TYPE: { r: "OFFICIAL_CP_TYPE", l: "Druh " },
  OFFICIAL_CP_PRICE: { r: "OFFICIAL_CP_PRICE", l: "Pořizovací cena" },

  OFFICIAL_CORPORATION_SHARE_SEPARATOR: {
    r: "OFFICIAL_CORPORATION_SHARE_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem...",
    subhead: true,
  },
  OFFICIAL_CORPORATION_SHARE: {
    r: "OFFICIAL_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem, pokud hodnota tohoto podílu přesahuje částku 50 000,- Kč anebo částku 100 00,- Kč, jde-li o podíly u více obchodních korporací",
  },
  OFFICIAL_CS_ADDRESS: {
    r: "OFFICIAL_CS_ADDRESS",
    l: "Sídlo obchodní korporace",
  },
  OFFICIAL_CS_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_CS_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_CS_NAME: {
    r: "OFFICIAL_CS_NAME",
    l: "Obchodní firma/název obchodní korporace",
  },
  OFFICIAL_CS_NOTE: { r: "OFFICIAL_CS_NOTE", l: "Poznámka" },

  OFFICIAL_CHATTEL_SEPARATOR: {
    r: "OFFICIAL_CHATTEL_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Věci movité nabyté v průběhu kalendářního roku...",
    subhead: true,
  },
  OFFICIAL_CHATTEL: {
    r: "OFFICIAL_CHATTEL",
    l: "Věci movité nabyté v průběhu kalendářního roku, jejichž hodnota ve svém souhrnu, do něhož se nezapočítávají věci, jejichž cena je nižší než 25 000,- Kč, přesáhla částku 500 000,- Kč",
  },
  OFFICIAL_CHATTEL_ACQUISITION: {
    r: "OFFICIAL_CHATTEL_ACQUISITION",
    l: "Způsob nabytí",
  },
  OFFICIAL_CHATTEL_NOTE: { r: "OFFICIAL_CHATTEL_NOTE", l: "Poznámka" },
  OFFICIAL_CHATTEL_PRICE: { r: "OFFICIAL_CHATTEL_PRICE", l: "Pořizovací cena" },
  OFFICIAL_CHATTEL_TYPE: { r: "OFFICIAL_CHATTEL_TYPE", l: "Druh movité věci" },

  OFFICIAL_INCOME_SEPARATOR: {
    r: "OFFICIAL_INCOME_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
    subhead: true,
  },
  OFFICIAL_INCOME: {
    r: "OFFICIAL_INCOME",
    l: "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
  },
  OFFICIAL_INCOME_ADDRESS: {
    r: "OFFICIAL_INCOME_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  OFFICIAL_INCOME_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_INCOME_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_INCOME_LEGAL_PERSON_NAME: {
    r: "OFFICIAL_INCOME_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OFFICIAL_INCOME_NOTE: { r: "OFFICIAL_INCOME_NOTE", l: "Poznámka" },
  OFFICIAL_INCOME_PRICE: { r: "OFFICIAL_INCOME_PRICE", l: "Výše příjmu" },
  OFFICIAL_INCOME_PSC: { r: "OFFICIAL_INCOME_PSC", l: "PSČ" },
  OFFICIAL_INCOME_TYPE: { r: "OFFICIAL_INCOME_TYPE", l: "Druh příjmu" },
  OFFICIAL_INCOME_OTHER: { r: "OFFICIAL_INCOME_OTHER", l: "Zdroj - jiný" },

  OFFICIAL_LIABILITY_SEPARATOR: {
    r: "OFFICIAL_LIABILITY_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše přesáhla ke dni 1. září kalendářního roku částku 100 000,- Kč",
    subhead: true,
  },
  OFFICIAL_LIABILITY: {
    r: "OFFICIAL_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše přesáhla ke dni 1. září kalendářního roku částku 100 000,- Kč",
  },
  OFFICIAL_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "OFFICIAL_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  OFFICIAL_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_LIABILITY_LEGAL_PERSON_NAME: {
    r: "OFFICIAL_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OFFICIAL_LIABILITY_NOTE: { r: "OFFICIAL_LIABILITY_NOTE", l: "Poznámka" },
  OFFICIAL_LIABILITY_PRICE: {
    r: "OFFICIAL_LIABILITY_PRICE",
    l: "Výše závazku",
  },
  OFFICIAL_LIABILITY_TYPE: { r: "OFFICIAL_LIABILITY_TYPE", l: "Druh závazku" },
  STATEMENT_YES_NO: { r: "STATEMENT_YES_NO", l: "Ano / Ne" },
};

const helpCategoriesEnum = {
  GENERAL_SEPARATOR: {
    r: "GENERAL_SEPARATOR",
    l: "Obecné",
    subhead: true,
    bold: true,
  },
  REQUEST_SEPARATOR: {
    r: "REQUEST_SEPARATOR",
    l: "Žádost o nahlížení / Podnět k prošetření",
    subhead: true,
    bold: true,
  },
  //INITIATIVE_SEPARATOR: { r: 'INITIATIVE_SEPARATOR', l: "Podnět k prošetření", subhead: true, bold: true },
  OVM: {
    r: "OVM",
    l: "Podpůrný (zapisující) orgán",
    subhead: true,
    bold: true,
  },
  IN: { r: "IN", l: "Vstupní oznámení", subhead: true, bold: true },
  ON: { r: "ON", l: "Průběžné oznámení", subhead: true, bold: true },
  OUT: { r: "OUT", l: "Výstupní oznámení", subhead: true, bold: true },
  POINT3: {
    r: "POINT3",
    l: "Oznámení podle Čl. II bodu 3",
    subhead: true,
    bold: true,
    historical: true,
  },
  POINT4: {
    r: "POINT4",
    l: "Oznámení podle Čl. II bodu 4",
    subhead: true,
    bold: true,
    historical: true,
  },
  OFFICIAL: {
    r: "OFFICIAL",
    l: "Oznámení pro poslance a senátory",
    subhead: true,
    bold: true,
    historical: true,
  },
};

const helpGeneralEnum = {
  PUBLIC_HOME_SEARCH: {
    r: "PUBLIC_HOME_SEARCH",
    l: "Hlavní stránka - Hledat osobu",
  },
  HOUSE_NUMBER: { r: "HOUSE_NUMBER", l: "Číslo popisné / číslo orientační" },
  //ADD_REMOVE_STATEMENT: { r: 'ADD_REMOVE_STATEMENT', l: 'Přidat / odebrat oznámení' },
  ADD_REMOVE_WP: { r: "ADD_REMOVE_WP", l: "Přidat / odebrat funkci" },
  STATEMENT_TYPE: { r: "STATEMENT_TYPE", l: "Druh oznámení" },

  ADD_REMOVE_STATEMENT: {
    r: "ADD_REMOVE_STATEMENT",
    l: "Přidat / odebrat oznámení",
    subhead: true,
  },
  ADD_REMOVE_ASSOCIATES: {
    r: "ADD_REMOVE_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  ADD_REMOVE_BUSSINESS: {
    r: "ADD_REMOVE_BUSSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  ADD_REMOVE_CP: {
    r: "ADD_REMOVE_CP",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  ADD_REMOVE_CS: { r: "ADD_REMOVE_CS", l: "Podíl v obchodní korporaci..." },
  ADD_REMOVE_CHATTELS: { r: "ADD_REMOVE_CHATTELS", l: "Jiné věci movité..." },
  ADD_REMOVE_INCOMES: {
    r: "ADD_REMOVE_INCOMES",
    l: "Jakékoliv peněžité příjmy...",
  },
  ADD_REMOVE_LIABILITIES: {
    r: "ADD_REMOVE_LIABILITIES",
    l: "Nesplacené závazky, zejména půjčky a úvěry...",
  },
  ADD_REMOVE_MEDIA: {
    r: "ADD_REMOVE_MEDIA",
    l: "Provozování rozhlasového nebo televizního vysílání...",
  },
  ADD_REMOVE_OM: {
    r: "ADD_REMOVE_OM",
    l: "Člen statutárního orgánu, člen řídícího...",
  },
  ADD_REMOVE_OC: {
    r: "ADD_REMOVE_OC",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu...",
  },
  ADD_REMOVE_REALTIES: { r: "ADD_REMOVE_REALTIES", l: "Věci nemovité" },
  STATEMENT: {
    r: "STATEMENT",
    l: "Oznámení",
    subhead: true,
  },
  STATEMENT_YES_NO: { r: "STATEMENT_YES_NO", l: "Ano / Ne" },
};

const helpRequestInitiativeEnum = {
  REQUEST_SEPARATOR: {
    r: "REQUEST_SEPARATOR",
    l: "Žádost o nahlížení na neveřejné oznámení",
    subhead: true,
    bold: true,
  },
  HOUSE_NUMBER: { r: "HOUSE_NUMBER", l: "Číslo popisné / číslo orientační" },
  REQUEST_ADRESS: { r: "REQUEST_ADRESS", l: "Adresa pro doručování" },
  REQUEST_TEXT: { r: "REQUEST_TEXT", l: "Obsah - Text" },
  INITIATIVE_SEPARATOR: {
    r: "INITIATIVE_SEPARATOR",
    l: "Podnět k prošetření",
    subhead: true,
    bold: true,
  },
  INITIATIVE_ADRESS: { r: "INITIATIVE_ADRESS", l: "Adresa pro doručování" },
  INITIATIVE_TEXT: { r: "INITIATIVE_TEXT", l: "Obsah - Text" },
};

const helpOvmEnum = {
  OVM_BTN_ADD: { r: "OVM_BTN_ADD", l: "Přidat funkcionáře" },
  OVM_BTN_IMPORT: { r: "OVM_BTN_IMPORT", l: "Import csv ze souboru" },
  OVM_BTN_TEMPLATE: { r: "OVM_BTN_TEMPLATE", l: "Šablona xlsx ke stažení" },
  OVM_BIRTH_COUNTRY: { r: "OVM_BIRTH_COUNTRY", l: "Stát narození" },
  OVM_BIRTH_MUNICIPALITY: { r: "OVM_BIRTH_MUNICIPALITY", l: "Obec narození" },
  OVM_BTN_GENERATE: { r: "OVM_BTN_GENERATE", l: "Generovat jméno a heslo" },
  OVM_WP: { r: "OVM_WP", l: "Funkce" },
  OVM_ORG: { r: "OVM_ORG", l: "Organizace" },
  OVM_WP_START: { r: "OVM_WP_START", l: "Datum zahájení výkonu funkce" },
  OVM_WP_FILL_START: {
    r: "OVM_WP_FILL_START",
    l: "Datum předání informace o zápisu zahájení výkonu funkce",
  },
  OVM_WP_END: { r: "OVM_WP_END", l: "Datum ukončení výkonu funkce" },
  OVM_WP_FILL_END: {
    r: "OVM_WP_FILL_END",
    l: "Datum předání informace o zápisu ukončení výkonu funkce",
  },
};

const helpInEnum = {
  IN_INFO: {
    r: "IN_INFO",
    l: "Vstupní oznámení - Všeobecné údaje",
    subhead: true,
  },
  IN_BIRTH_COUNRTY: { r: "IN_BIRTH_COUNRTY", l: "Stát narození" },
  IN_BIRTH_MUNICIPALITY: { r: "IN_BIRTH_MUNICIPALITY", l: "Obec narození" },

  IN_ADDRESS: {
    r: "IN_ADDRESS",
    l: "Vstupní oznámení - Adresa pro doručování",
    subhead: true,
  },
  IN_EMAIL: { r: "IN_EMAIL", l: "E-mail" },
  HOUSE_NUMBER: { r: "HOUSE_NUMBER", l: "Číslo popisné / číslo orientační" },

  IN_STATEMENT_TYPE_SEPARATOR: {
    r: "IN_STATEMENT_TYPE_SEPARATOR",
    l: "Vstupní  oznámení - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  IN_STATEMENT_TYPE: {
    r: "IN_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  STATEMENT_TYPE: { r: "STATEMENT_TYPE", l: "Druh oznámení" },
  IN_WP_DATE: { r: "IN_WP_DATE", l: "Datum zahájení výkonu funkce" },

  IN_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "IN_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Vstupní  oznámení - Podnikání nebo provozování jiné samostatné výdělečné činnosti",
    subhead: true,
  },
  IN_NATURAL_PERSON_BUSINESS: {
    r: "IN_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  IN_NPB_SUBJECT: { r: "IN_NPB_SUBJECT", l: "Předmět" },
  IN_NPB_METHOD: { r: "IN_NPB_METHOD", l: "Způsob" },
  IN_NPB_PLACE: {
    r: "IN_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  IN_NPB_NOTE: { r: "IN_NPB_NOTE", l: "Poznámka" },

  IN_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "IN_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Vstupní  oznámení - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  IN_LEGAL_BUSINESS_ASSOCIATES: {
    r: "IN_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  IN_LBA_IDENTIFICATION_NUMBER: { r: "IN_LBA_IDENTIFICATION_NUMBER", l: "IČO" },
  IN_LBA_NAME: { r: "IN_LBA_NAME", l: "Obchodní firma/název" },
  IN_LBA_ADDRESS: { r: "IN_LBA_ADDRESS", l: "Sídlo právnické osoby" },
  IN_LBA_NOTE: { r: "IN_LBA_NOTE", l: "Poznámka" },

  IN_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "IN_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Vstupní  oznámení - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  IN_ORGANIZATION_MEMBER: {
    r: "IN_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  IN_OM_IDENTIFICATION_NUMBER: { r: "IN_OM_IDENTIFICATION_NUMBER", l: "IČO" },
  IN_OM_TYPE: { r: "IN_OM_TYPE", l: "Druh orgánu" },
  IN_OM_NAME: { r: "IN_OM_NAME", l: "Obchodní firma/název" },
  IN_OM_ADDRESS: { r: "IN_OM_ADDRESS", l: "Sídlo právnické osoby" },
  IN_OM_NOTE: { r: "IN_OM_NOTE", l: "Poznámka" },

  IN_MEDIUM_SEPARATOR: {
    r: "IN_MEDIUM_SEPARATOR",
    l: "Vstupní  oznámení - Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
    subhead: true,
  },
  IN_MEDIUM: {
    r: "IN_MEDIUM",
    l: "Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
  },
  IN_MEDIUM_LEGAL_PERSON_NAME: {
    r: "IN_MEDIUM_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název (provozovatele/vydavatele)",
  },
  IN_MEDIUM_IDENTIFICATION_NUMBER: {
    r: "IN_MEDIUM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  IN_MEDIUM_ADDRESS: { r: "IN_MEDIUM_ADDRESS", l: "Sídlo právnické osoby" },
  IN_MEDIUM_NAME: { r: "IN_MEDIUM_NAME", l: "Název média" },
  IN_MEDIUM_NOTE: { r: "IN_MEDIUM_NOTE", l: "Poznámka" },

  IN_OTHER_CONTRACTS_SEPARATOR: {
    r: "IN_OTHER_CONTRACTS_SEPARATOR",
    l: "Vstupní  oznámení - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  IN_OTHER_CONTRACTS: {
    r: "IN_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  IN_OC_TYPE: { r: "IN_OC_TYPE", l: "Druh činnosti" },
  IN_OC_FIRST_NAME: { r: "IN_OC_FIRST_NAME", l: "Jméno" },
  IN_OC_LAST_NAME: { r: "IN_OC_LAST_NAME", l: "Příjmení" },
  IN_OC_LEGAL_PERSON_NAME: { r: "IN_OC_LEGAL_PERSON_NAME", l: "Jméno/název" },
  IN_OC_IDENTIFICATION_NUMBER: { r: "IN_OC_IDENTIFICATION_NUMBER", l: "IČO" },
  IN_OC_ADDRESS: {
    r: "IN_OC_ADDRESS",
    l: "Místo výkonu podnikání/sídlo právnické osoby",
  },
  IN_OC_NOTE: { r: "IN_OC_NOTE", l: "Poznámka" },

  IN_REALTY_SEPARATOR: {
    r: "IN_REALTY_SEPARATOR",
    l: "Vstupní oznámení - Věci nemovité",
    subhead: true,
  },
  IN_REALTY: { r: "IN_REALTY", l: "Věci nemovité" },
  IN_REALTY_IS_CADASTRE: {
    r: "IN_REALTY_IS_CADASTRE",
    l: "Import z katastru nemovitostí",
  },
  IN_REALTY_IS_NOT_CADASTRE: {
    r: "IN_REALTY_IS_NOT_CADASTRE",
    l: "Individuální zadání",
  },
  IN_REALTY_LV: { r: "IN_REALTY_LV", l: "Číslo LV" },
  IN_REALTY_CADASTRE: {
    r: "IN_REALTY_CADASTRE",
    l: "Katastrální území",
  },
  IN_REALTY_NOTE: { r: "IN_REALTY_NOTE", l: "Poznámka" },
  IN_REALTY_TYPE: { r: "IN_REALTY_TYPE", l: "Druh nemovité věci/Specifikace druhu" },
  IN_REALTY_PARCEL_NUMBER: {
    r: "IN_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  IN_REALTY_OWNERSHIP: { r: "IN_REALTY_OWNERSHIP", l: "Vlastnictví" },
  IN_REALTY_ORIENTATION_NUMBER: {
    r: "IN_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },

  IN_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "IN_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Vstupní  oznámení - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
    subhead: true,
  },
  IN_COMMERCIAL_PAPERS: {
    r: "IN_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  IN_CP_TYPE: { r: "IN_CP_TYPE", l: "Druh " },
  IN_CP_ISSUER: { r: "IN_CP_ISSUER", l: "Emitent" },
  IN_CP_NOTE: { r: "IN_CP_NOTE", l: "Poznámka" },
  IN_CP_OWNERSHIP: { r: "IN_CP_OWNERSHIP", l: "Způsob vlastnictví" },

  IN_CORPORATION_SHARE_SEPARATOR: {
    r: "IN_CORPORATION_SHARE_SEPARATOR",
    l: "Vstupní  oznámení - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
    subhead: true,
  },
  IN_CORPORATION_SHARE: {
    r: "IN_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
  },
  IN_CS_IDENTIFICATION_NUMBER: { r: "IN_CS_IDENTIFICATION_NUMBER", l: "IČO" },
  IN_CS_NAME: { r: "IN_CS_NAME", l: "Obchodní firma/název obchodní korporace" },
  IN_CS_ADDRESS: { r: "IN_CS_ADDRESS", l: "Sídlo obchodní korporace" },
  IN_CS_NOTE: { r: "IN_CS_NOTE", l: "Poznámka" },

  IN_CHATTEL_SEPARATOR: {
    r: "IN_CHATTEL_SEPARATOR",
    l: "Vstupní  oznámení - Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
    subhead: true,
  },
  IN_CHATTEL: {
    r: "IN_CHATTEL",
    l: "Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
  },
  IN_CHATTEL_TYPE: { r: "IN_CHATTEL_TYPE", l: "Druh movité věci" },
  IN_CHATTEL_PRICE: { r: "IN_CHATTEL_PRICE", l: "Cena obvyklá" },
  IN_CHATTEL_ACQUISITION: { r: "IN_CHATTEL_ACQUISITION", l: "Způsob nabytí" },
  IN_CHATTEL_NOTE: { r: "IN_CHATTEL_NOTE", l: "Poznámka" },

  IN_LIABILITY_SEPARATOR: {
    r: "IN_LIABILITY_SEPARATOR",
    l: "Vstupní  oznámení - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
    subhead: true,
  },
  IN_LIABILITY: {
    r: "IN_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
  },
  IN_LIABILITY_TYPE: { r: "IN_LIABILITY_TYPE", l: "Druh závazku" },
  IN_LIABILITY_PRICE: { r: "IN_LIABILITY_PRICE", l: "Výše závazku" },
  IN_LIABILITY_LEGAL_PERSON_NAME: {
    r: "IN_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  IN_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "IN_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  IN_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "IN_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  IN_LIABILITY_NOTE: { r: "IN_LIABILITY_NOTE", l: "Poznámka" },
};

const helpOnEnum = {
  ON_INFO: {
    r: "ON_INFO",
    l: "Průběžné oznámení - Všeobecné údaje",
    subhead: true,
  },
  ON_BIRTH_COUNRTY: { r: "ON_BIRTH_COUNRTY", l: "Stát narození" },
  ON_BIRTH_MUNICIPALITY: { r: "ON_BIRTH_MUNICIPALITY", l: "Obec narození" },

  ON_ADDRESS: {
    r: "ON_ADDRESS",
    l: "Průběžné oznámení - Adresa pro doručování",
    subhead: true,
  },
  ON_EMAIL: { r: "ON_EMAIL", l: "E-mail" },
  HOUSE_NUMBER: { r: "HOUSE_NUMBER", l: "Číslo popisné / číslo orientační" },

  ON_STATEMENT_TYPE_SEPARATOR: {
    r: "ON_STATEMENT_TYPE_SEPARATOR",
    l: "Průběžné oznámení - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  ON_STATEMENT_TYPE: {
    r: "ON_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  STATEMENT_TYPE: { r: "STATEMENT_TYPE", l: "Druh oznámení" },
  ON_FROM_DATE: { r: "ON_FROM_DATE", l: "Období od" },
  ON_TO_DATE: { r: "ON_TO_DATE", l: "Období do" },

  ON_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "ON_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Průběžné oznámení - Podnikání nebo provozování jiné samostatné výdělečné výdělečné činnosti",
    subhead: true,
  },
  ON_NATURAL_PERSON_BUSINESS: {
    r: "ON_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  ON_NPB_SUBJECT: { r: "ON_NPB_SUBJECT", l: "Předmět" },
  ON_NPB_METHOD: { r: "ON_NPB_METHOD", l: "Způsob" },
  ON_NPB_PLACE: {
    r: "ON_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  ON_NPB_NOTE: { r: "ON_NPB_NOTE", l: "Poznámka" },

  ON_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "ON_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Průběžné oznámení - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  ON_LEGAL_BUSINESS_ASSOCIATES: {
    r: "ON_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  ON_LBA_IDENTIFICATION_NUMBER: { r: "ON_LBA_IDENTIFICATION_NUMBER", l: "IČO" },
  ON_LBA_NAME: { r: "ON_LBA_NAME", l: "Obchodní firma/název" },
  ON_LBA_ADDRESS: { r: "ON_LBA_ADDRESS", l: "Sídlo právnické osoby" },
  ON_LBA_NOTE: { r: "ON_LBA_NOTE", l: "Poznámka" },

  ON_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "ON_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Průběžné oznámení - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  ON_ORGANIZATION_MEMBER: {
    r: "ON_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  ON_OM_IDENTIFICATION_NUMBER: { r: "ON_OM_IDENTIFICATION_NUMBER", l: "IČO" },
  ON_OM_TYPE: { r: "ON_OM_TYPE", l: "Druh orgánu" },
  ON_OM_NAME: { r: "ON_OM_NAME", l: "Obchodní firma/název" },
  ON_OM_ADDRESS: { r: "ON_OM_ADDRESS", l: "Sídlo právnické osoby" },
  ON_OM_NOTE: { r: "ON_OM_NOTE", l: "Poznámka" },

  ON_MEDIUM_SEPARATOR: {
    r: "ON_MEDIUM_SEPARATOR",
    l: "Průběžné  oznámení - Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
    subhead: true,
  },
  ON_MEDIUM: {
    r: "ON_MEDIUM",
    l: "Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
  },
  ON_MEDIUM_LEGAL_PERSON_NAME: {
    r: "ON_MEDIUM_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název (provozovatele/vydavatele)",
  },
  ON_MEDIUM_IDENTIFICATION_NUMBER: {
    r: "ON_MEDIUM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  ON_MEDIUM_ADDRESS: { r: "ON_MEDIUM_ADDRESS", l: "Sídlo právnické osoby" },
  ON_MEDIUM_NAME: { r: "ON_MEDIUM_NAME", l: "Název média" },
  ON_MEDIUM_NOTE: { r: "ON_MEDIUM_NOTE", l: "Poznámka" },

  ON_OTHER_CONTRACTS_SEPARATOR: {
    r: "ON_OTHER_CONTRACTS_SEPARATOR",
    l: "Průběžné oznámení - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  ON_OTHER_CONTRACTS: {
    r: "ON_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  ON_OC_TYPE: { r: "ON_OC_TYPE", l: "Druh činnosti" },
  ON_OC_FIRST_NAME: { r: "ON_OC_FIRST_NAME", l: "Jméno" },
  ON_OC_LAST_NAME: { r: "ON_OC_LAST_NAME", l: "Příjmení" },
  ON_OC_LEGAL_PERSON_NAME: { r: "ON_OC_LEGAL_PERSON_NAME", l: "Jméno/název" },
  ON_OC_IDENTIFICATION_NUMBER: { r: "ON_OC_IDENTIFICATION_NUMBER", l: "IČO" },
  ON_OC_ADDRESS: {
    r: "ON_OC_ADDRESS",
    l: "Místo výkonu podnikání/sídlo právnické osoby",
  },
  ON_OC_NOTE: { r: "ON_OC_NOTE", l: "Poznámka" },

  ON_REALTY_SEPARATOR: {
    r: "ON_REALTY_SEPARATOR",
    l: "Průběžné oznámení - Věci nemovité",
    subhead: true,
  },
  ON_REALTY: { r: "ON_REALTY", l: "Věci nemovité" },
  ON_REALTY_IS_CADASTRE: {
    r: "ON_REALTY_IS_CADASTRE",
    l: "Import z katastru nemovitostí",
  },
  ON_REALTY_IS_NOT_CADASTRE: {
    r: "ON_REALTY_IS_NOT_CADASTRE",
    l: "Individuální zadání",
  },
  ON_REALTY_HASFILEREF: {
    r: "ON_REALTY_HASFILEREF",
    l: "Oznámení o nemovitostech bylo podáno formou datového souboru",
  },
  ON_REALTY_LV: { r: "ON_REALTY_LV", l: "Číslo LV" },
  ON_REALTY_CADASTRE: {
    r: "ON_REALTY_CADASTRE",
    l: "Katastrální území",
  },

  ON_REALTY_ACQUISITION: { r: "ON_REALTY_ACQUISITION", l: "Způsob nabytí" },
  ON_REALTY_PARCEL_NUMBER: {
    r: "ON_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  ON_REALTY_PRICE: { r: "ON_REALTY_PRICE", l: "Pořizovací cena" },
  ON_REALTY_NOTE: { r: "ON_REALTY_NOTE", l: "Poznámka" },
  ON_REALTY_TYPE: { r: "ON_REALTY_TYPE", l: "Druh nemovité věci/Specifikace druhu" },
  ON_REALTY_ORIENTATION_NUMBER: {
    r: "ON_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },
  ON_REALTY_OWNERSHIP: { r: "ON_REALTY_OWNERSHIP", l: "Vlastnictví" },

  ON_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "ON_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Průběžné oznámení - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
    subhead: true,
  },
  ON_COMMERCIAL_PAPERS: {
    r: "ON_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  ON_CP_TYPE: { r: "ON_CP_TYPE", l: "Druh " },
  ON_CP_ISSUER: { r: "ON_CP_ISSUER", l: "Emitent" },
  ON_CP_PRICE: { r: "ON_CP_PRICE", l: "Pořizovací cena" },
  ON_CP_NOTE: { r: "ON_CP_NOTE", l: "Poznámka" },

  ON_CORPORATION_SHARE_SEPARATOR: {
    r: "ON_CORPORATION_SHARE_SEPARATOR",
    l: "Průběžné oznámení - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
    subhead: true,
  },
  ON_CORPORATION_SHARE: {
    r: "ON_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
  },
  ON_CS_IDENTIFICATION_NUMBER: { r: "ON_CS_IDENTIFICATION_NUMBER", l: "IČO" },
  ON_CS_NAME: { r: "ON_CS_NAME", l: "Obchodní firma/název obchodní korporace" },
  ON_CS_ADDRESS: { r: "ON_CS_ADDRESS", l: "Sídlo obchodní korporace" },
  ON_CS_NOTE: { r: "ON_CS_NOTE", l: "Poznámka" },

  ON_CHATTEL_SEPARATOR: {
    r: "ON_CHATTEL_SEPARATOR",
    l: "Průběžné oznámení - Jiné věci movité určené podle druhu, nabyté v průběhu kalendářního roku, jejichž hodnota ve svém souhrnu, do něhož se nezapočítávají věci, jejichž hodnota je nižší než 50 000,- Kč, přesáhla částku 500 000,- Kč.",
    subhead: true,
  },
  ON_CHATTEL: {
    r: "ON_CHATTEL",
    l: "Jiné věci movité určené podle druhu, nabyté v průběhu kalendářního roku, jejichž hodnota ve svém souhrnu, do něhož se nezapočítávají věci, jejichž hodnota je nižší než 50 000,- Kč, přesáhla částku 500 000,- Kč.",
  },
  ON_CHATTEL_TYPE: { r: "ON_CHATTEL_TYPE", l: "Druh movité věci" },
  ON_CHATTEL_PRICE: { r: "ON_CHATTEL_PRICE", l: "Pořizovací cena" },
  ON_CHATTEL_ACQUISITION: { r: "ON_CHATTEL_ACQUISITION", l: "Způsob nabytí" },
  ON_CHATTEL_NOTE: { r: "ON_CHATTEL_NOTE", l: "Poznámka" },

  ON_INCOME_SEPARATOR: {
    r: "ON_INCOME_SEPARATOR",
    l: "Průběžné oznámení - Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
    subhead: true,
  },
  ON_INCOME: {
    r: "ON_INCOME",
    l: "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
  },
  ON_INCOME_TYPE: { r: "ON_INCOME_TYPE", l: "Druh příjmu" },
  ON_INCOME_PRICE: { r: "ON_INCOME_PRICE", l: "Výše příjmu" },
  ON_INCOME_OTHER: { r: "ON_INCOME_OTHER", l: "Zdroj - jiný" },
  ON_INCOME_LEGAL_PERSON_NAME: {
    r: "ON_INCOME_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  ON_INCOME_IDENTIFICATION_NUMBER: {
    r: "ON_INCOME_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  ON_INCOME_ADDRESS: { r: "ON_INCOME_ADDRESS", l: "Sídlo právnické osoby" },
  ON_INCOME_NOTE: { r: "ON_INCOME_NOTE", l: "Poznámka" },

  ON_LIABILITY_SEPARATOR: {
    r: "ON_LIABILITY_SEPARATOR",
    l: "Průběžné oznámení - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše přesáhla ke dni 31. prosince kalendářního roku, za který se oznámení podává, částku 100 000,- Kč",
    subhead: true,
  },
  ON_LIABILITY: {
    r: "ON_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše přesáhla ke dni 31. prosince kalendářního roku, za který se oznámení podává, částku 100 000,- Kč",
  },
  ON_LIABILITY_TYPE: { r: "ON_LIABILITY_TYPE", l: "Druh závazku" },
  ON_LIABILITY_PRICE: { r: "ON_LIABILITY_PRICE", l: "Výše závazku" },
  ON_LIABILITY_LEGAL_PERSON_NAME: {
    r: "ON_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  ON_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "ON_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  ON_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "ON_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: " Sídlo právnické osoby",
  },
  ON_LIABILITY_NOTE: { r: "ON_LIABILITY_NOTE", l: "Poznámka" },
};

const helpOutEnum = {
  OUT_INFO: {
    r: "OUT_INFO",
    l: "Výstupní oznámení - Všeobecné údaje",
    subhead: true,
  },
  OUT_BIRTH_COUNRTY: { r: "OUT_BIRTH_COUNRTY", l: "Stát narození" },
  OUT_BIRTH_MUNICIPALITY: { r: "OUT_BIRTH_MUNICIPALITY", l: "Obec narození" },

  OUT_ADDRESS: {
    r: "OUT_ADDRESS",
    l: "Výstupní oznámení - Adresa pro doručování",
    subhead: true,
  },
  OUT_EMAIL: { r: "OUT_EMAIL", l: "E-mail" },
  HOUSE_NUMBER: { r: "HOUSE_NUMBER", l: "Číslo popisné / číslo orientační" },

  OUT_STATEMENT_TYPE_SEPARATOR: {
    r: "OUT_STATEMENT_TYPE_SEPARATOR",
    l: "Výstupní oznámení - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  OUT_STATEMENT_TYPE: {
    r: "OUT_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  STATEMENT_TYPE: { r: "STATEMENT_TYPE", l: "Druh oznámení" },
  OUT_FROM_DATE: { r: "OUT_FROM_DATE", l: "Období od" },
  OUT_TO_DATE: { r: "OUT_TO_DATE", l: "Období do" },

  OUT_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "OUT_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Výstupní oznámení - Podnikání nebo provozování jiné samostatné výdělečné činnosti",
    subhead: true,
  },
  OUT_NATURAL_PERSON_BUSINESS: {
    r: "OUT_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  OUT_NPB_SUBJECT: { r: "OUT_NPB_SUBJECT", l: "Předmět" },
  OUT_NPB_METHOD: { r: "OUT_NPB_METHOD", l: "Způsob" },
  OUT_NPB_PLACE: {
    r: "OUT_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  OUT_NPB_NOTE: { r: "OUT_NPB_NOTE", l: "Poznámka" },

  OUT_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "OUT_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Výstupní oznámení - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  OUT_LEGAL_BUSINESS_ASSOCIATES: {
    r: "OUT_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  OUT_LBA_IDENTIFICATION_NUMBER: {
    r: "OUT_LBA_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OUT_LBA_NAME: { r: "OUT_LBA_NAME", l: "Obchodní firma/název" },
  OUT_LBA_ADDRESS: { r: "OUT_LBA_ADDRESS", l: "Sídlo právnické osoby" },
  OUT_LBA_NOTE: { r: "OUT_LBA_NOTE", l: "Poznámka" },

  OUT_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "OUT_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Výstupní oznámení - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  OUT_ORGANIZATION_MEMBER: {
    r: "OUT_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  OUT_OM_IDENTIFICATION_NUMBER: { r: "OUT_OM_IDENTIFICATION_NUMBER", l: "IČO" },
  OUT_OM_TYPE: { r: "OUT_OM_TYPE", l: "Druh orgánu" },
  OUT_OM_NAME: { r: "OUT_OM_NAME", l: "Obchodní firma/název" },
  OUT_OM_ADDRESS: { r: "OUT_OM_ADDRESS", l: "Sídlo právnické osoby" },
  OUT_OM_NOTE: { r: "OUT_OM_NOTE", l: "Poznámka" },

  OUT_MEDIUM_SEPARATOR: {
    r: "OUT_MEDIUM_SEPARATOR",
    l: "Výstupní  oznámení - Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
    subhead: true,
  },
  OUT_MEDIUM: {
    r: "OUT_MEDIUM",
    l: "Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
  },
  OUT_MEDIUM_LEGAL_PERSON_NAME: {
    r: "OUT_MEDIUM_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název (provozovatele/vydavatele)",
  },
  OUT_MEDIUM_IDENTIFICATION_NUMBER: {
    r: "OUT_MEDIUM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OUT_MEDIUM_ADDRESS: { r: "OUT_MEDIUM_ADDRESS", l: "Sídlo právnické osoby" },
  OUT_MEDIUM_NAME: { r: "OUT_MEDIUM_NAME", l: "Název média" },
  OUT_MEDIUM_NOTE: { r: "OUT_MEDIUM_NOTE", l: "Poznámka" },

  OUT_OTHER_CONTRACTS_SEPARATOR: {
    r: "OUT_OTHER_CONTRACTS_SEPARATOR",
    l: "Výstupní oznámení - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  OUT_OTHER_CONTRACTS: {
    r: "OUT_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  OUT_OC_TYPE: { r: "OUT_OC_TYPE", l: "Druh činnosti" },
  OUT_OC_FIRST_NAME: { r: "OUT_OC_FIRST_NAME", l: "Jméno" },
  OUT_OC_LAST_NAME: { r: "OUT_OC_LAST_NAME", l: "Příjmení" },
  OUT_OC_LEGAL_PERSON_NAME: { r: "OUT_OC_LEGAL_PERSON_NAME", l: "Jméno/název" },
  OUT_OC_IDENTIFICATION_NUMBER: { r: "OUT_OC_IDENTIFICATION_NUMBER", l: "IČO" },
  OUT_OC_ADDRESS: {
    r: "OUT_OC_ADDRESS",
    l: "Místo výkonu podnikání/sídlo právnické osoby",
  },
  OUT_OC_NOTE: { r: "OUT_OC_NOTE", l: "Poznámka" },

  OUT_REALTY_SEPARATOR: {
    r: "OUT_REALTY_SEPARATOR",
    l: "Výstupní  oznámení - Věci nemovité",
    subhead: true,
  },
  OUT_REALTY: { r: "OUT_REALTY", l: "Věci nemovité" },
  OUT_REALTY_IS_CADASTRE: {
    r: "OUT_REALTY_IS_CADASTRE",
    l: "Import z katastru nemovitostí",
  },
  OUT_REALTY_IS_NOT_CADASTRE: {
    r: "OUT_REALTY_IS_NOT_CADASTRE",
    l: "Individuální zadání",
  },
  OUT_REALTY_HASFILEREF: {
    r: "OUT_REALTY_HASFILEREF",
    l: "Oznámení o nemovitostech bylo podáno formou datového souboru",
  },
  OUT_REALTY_LV: { r: "OUT_REALTY_LV", l: "Číslo LV" },
  OUT_REALTY_CADASTRE: {
    r: "OUT_REALTY_CADASTRE",
    l: "Katastrální území",
  },

  OUT_REALTY_ACQUISITION: { r: "OUT_REALTY_ACQUISITION", l: "Způsob nabytí" },
  OUT_REALTY_PARCEL_NUMBER: {
    r: "OUT_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  OUT_REALTY_PRICE: { r: "OUT_REALTY_PRICE", l: "Pořizovací cena" },
  OUT_REALTY_NOTE: { r: "OUT_REALTY_NOTE", l: "Poznámka" },
  OUT_REALTY_TYPE: { r: "OUT_REALTY_TYPE", l: "Druh nemovité věci/Specifikace druhu" },
  OUT_REALTY_ORIENTATION_NUMBER: {
    r: "OUT_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },
  OUT_REALTY_OWNERSHIP: { r: "OUT_REALTY_OWNERSHIP", l: "Vlastnictví" },

  OUT_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "OUT_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Výstupní oznámení - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
    subhead: true,
  },
  OUT_COMMERCIAL_PAPERS: {
    r: "OUT_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  OUT_CP_TYPE: { r: "OUT_CP_TYPE", l: "Druh " },
  OUT_CP_ISSUER: { r: "OUT_CP_ISSUER", l: "Emitent" },
  OUT_CP_PRICE: { r: "OUT_CP_PRICE", l: "Pořizovací cena" },
  OUT_CP_NOTE: { r: "OUT_CP_NOTE", l: "Poznámka" },

  OUT_CORPORATION_SHARE_SEPARATOR: {
    r: "OUT_CORPORATION_SHARE_SEPARATOR",
    l: "Výstupní oznámení - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
    subhead: true,
  },
  OUT_CORPORATION_SHARE: {
    r: "OUT_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
  },
  OUT_CS_IDENTIFICATION_NUMBER: { r: "OUT_CS_IDENTIFICATION_NUMBER", l: "IČO" },
  OUT_CS_NAME: {
    r: "OUT_CS_NAME",
    l: "Obchodní firma/název obchodní korporace",
  },
  OUT_CS_ADDRESS: { r: "OUT_CS_ADDRESS", l: "Sídlo obchodní korporace" },
  OUT_CS_NOTE: { r: "OUT_CS_NOTE", l: "Poznámka" },

  OUT_CHATTEL_SEPARATOR: {
    r: "OUT_CHATTEL_SEPARATOR",
    l: "Výstupní oznámení - Jiné věci movité určené podle druhu, nabyté v průběhu kalendářního roku, jejichž hodnota ve svém souhrnu, do něhož se nezapočítávají věci, jejichž hodnota je nižší než 50 000,- Kč, přesáhla částku 500 000,- Kč.",
    subhead: true,
  },
  OUT_CHATTEL: {
    r: "OUT_CHATTEL",
    l: "Jiné věci movité určené podle druhu, nabyté v průběhu kalendářního roku, jejichž hodnota ve svém souhrnu, do něhož se nezapočítávají věci, jejichž hodnota je nižší než 50 000,- Kč, přesáhla částku 500 000,- Kč.",
  },
  OUT_CHATTEL_TYPE: { r: "OUT_CHATTEL_TYPE", l: "Druh movité věci" },
  OUT_CHATTEL_PRICE: { r: "OUT_CHATTEL_PRICE", l: "Pořizovací cena" },
  OUT_CHATTEL_ACQUISITION: { r: "OUT_CHATTEL_ACQUISITION", l: "Způsob nabytí" },
  OUT_CHATTEL_NOTE: { r: "OUT_CHATTEL_NOTE", l: "Poznámka" },

  OUT_INCOME_SEPARATOR: {
    r: "OUT_INCOME_SEPARATOR",
    l: "Výstupní oznámení - Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhla ke dni ukončení výkonu funkce částku 100 000,- Kč",
    subhead: true,
  },
  OUT_INCOME: {
    r: "OUT_INCOME",
    l: "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhla ke dni ukončení výkonu funkce částku 100 000,- Kč",
  },
  OUT_INCOME_TYPE: { r: "OUT_INCOME_TYPE", l: "Druh příjmu" },
  OUT_INCOME_PRICE: { r: "OUT_INCOME_PRICE", l: "Výše příjmu" },
  OUT_INCOME_OTHER: { r: "OUT_INCOME_OTHER", l: "Zdroj - jiný" },
  OUT_INCOME_LEGAL_PERSON_NAME: {
    r: "OUT_INCOME_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OUT_INCOME_IDENTIFICATION_NUMBER: {
    r: "OUT_INCOME_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OUT_INCOME_ADDRESS: { r: "OUT_INCOME_ADDRESS", l: "Sídlo právnické osoby" },
  OUT_INCOME_NOTE: { r: "OUT_INCOME_NOTE", l: "Poznámka" },

  OUT_LIABILITY_SEPARATOR: {
    r: "OUT_LIABILITY_SEPARATOR",
    l: "Výstupní oznámení - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše ke dni ukončení výkonu funkce přesáhla částku 100 000,- Kč",
    subhead: true,
  },
  OUT_LIABILITY: {
    r: "OUT_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše ke dni ukončení výkonu funkce přesáhla částku 100 000,- Kč",
  },
  OUT_LIABILITY_TYPE: { r: "OUT_LIABILITY_TYPE", l: "Druh závazku" },
  OUT_LIABILITY_PRICE: { r: "OUT_LIABILITY_PRICE", l: "Výše závazku" },
  OUT_LIABILITY_LEGAL_PERSON_NAME: {
    r: "OUT_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OUT_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "OUT_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OUT_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "OUT_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  OUT_LIABILITY_NOTE: { r: "OUT_LIABILITY_NOTE", l: "Poznámka" },
};

const helpPoint3Enum = {
  POINT3_INFO: {
    r: "POINT3_INFO",
    l: "Oznámení podle Čl. II bodu 3 - Všeobecné údaje",
    subhead: true,
  },
  POINT3_BIRTH_COUNRTY: { r: "POINT3_BIRTH_COUNRTY", l: "Stát narození" },
  POINT3_BIRTH_MUNICIPALITY: {
    r: "POINT3_BIRTH_MUNICIPALITY",
    l: "Obec narození",
  },

  POINT3_ADDRESS: {
    r: "POINT3_ADDRESS",
    l: "Oznámení podle Čl. II bodu 3 - Adresa pro doručování",
    subhead: true,
  },
  POINT3_EMAIL: { r: "POINT3_EMAIL", l: "E-mail" },

  POINT3_STATEMENT_TYPE_SEPARATOR: {
    r: "POINT3_STATEMENT_TYPE_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  POINT3_STATEMENT_TYPE: {
    r: "POINT3_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },

  POINT3_CHATTEL_SEPARATOR: {
    r: "POINT3_CHATTEL_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
    subhead: true,
  },
  POINT3_CHATTEL: {
    r: "POINT3_CHATTEL",
    l: "Jiné věci movité určené podle druhu, jejichž cena, která je v daném místě a čase obvyklá, přesahuje v jednotlivém případě částku 500 000,- Kč",
  },
  POINT3_CHATTEL_TYPE: { r: "POINT3_CHATTEL_TYPE", l: "Druh movité věci" },
  POINT3_CHATTEL_PRICE: { r: "POINT3_CHATTEL_PRICE", l: "Pořizovací cena" },
  POINT3_CHATTEL_ACQUISITION: {
    r: "POINT3_CHATTEL_ACQUISITION",
    l: "Způsob nabytí",
  },
  POINT3_CHATTEL_NOTE: { r: "POINT3_CHATTEL_NOTE", l: "Poznámka" },
  POINT3_CHATTEL_OWNERSHIP: {
    r: "POINT3_CHATTEL_OWNERSHIP",
    l: "Způsob vlastnictví",
  },

  POINT3_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "POINT3_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
    subhead: true,
  },
  POINT3_COMMERCIAL_PAPERS: {
    r: "POINT3_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená",
  },
  POINT3_CP_TYPE: { r: "POINT3_CP_TYPE", l: "Druh " },
  POINT3_CP_ISSUER: { r: "POINT3_CP_ISSUER", l: "Emitent" },
  POINT3_CP_PRICE: { r: "POINT3_CP_PRICE", l: "Pořizovací cena" },
  POINT3_CP_NOTE: { r: "POINT3_CP_NOTE", l: "Poznámka" },
  POINT3_CP_OWNERSHIP: { r: "POINT3_CP_OWNERSHIP", l: "Způsob vlastnictví" },

  POINT3_CORPORATION_SHARE_SEPARATOR: {
    r: "POINT3_CORPORATION_SHARE_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
    subhead: true,
  },
  POINT3_CORPORATION_SHARE: {
    r: "POINT3_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem",
  },
  POINT3_CS_IDENTIFICATION_NUMBER: {
    r: "POINT3_CS_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_CS_NAME: {
    r: "POINT3_CS_NAME",
    l: "Obchodní firma/název obchodní korporace",
  },
  POINT3_CS_PRICE: { r: "POINT3_CS_PRICE", l: "Hodnota obchodního podílu" },
  POINT3_CS_ADDRESS: { r: "POINT3_CS_ADDRESS", l: "Sídlo obchodní korporace" },
  POINT3_CS_NOTE: { r: "POINT3_CS_NOTE", l: "Poznámka" },
  POINT3_CS_OWNERSHIP: { r: "POINT3_CS_OWNERSHIP", l: "Způsob vlastnictví" },

  POINT3_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "POINT3_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  POINT3_LEGAL_BUSINESS_ASSOCIATES: {
    r: "POINT3_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  POINT3_LBA_IDENTIFICATION_NUMBER: {
    r: "POINT3_LBA_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_LBA_NAME: { r: "POINT3_LBA_NAME", l: "Obchodní firma/název" },
  POINT3_LBA_ADDRESS: { r: "POINT3_LBA_ADDRESS", l: "Sídlo právnické osoby" },
  POINT3_LBA_NOTE: { r: "POINT3_LBA_NOTE", l: "Poznámka" },

  POINT3_LIABILITY_SEPARATOR: {
    r: "POINT3_LIABILITY_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
    subhead: true,
  },
  POINT3_LIABILITY: {
    r: "POINT3_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich výše ke dni předcházejícímu dni zahájení výkonu funkce přesahuje v jednotlivém případě částku 100 000,- Kč",
  },
  POINT3_LIABILITY_TYPE: { r: "POINT3_LIABILITY_TYPE", l: "Druh závazku" },
  POINT3_LIABILITY_PRICE: { r: "POINT3_LIABILITY_PRICE", l: "Výše závazku" },
  POINT3_LIABILITY_LEGAL_PERSON_NAME: {
    r: "POINT3_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  POINT3_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "POINT3_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "POINT3_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  POINT3_LIABILITY_NOTE: { r: "POINT3_LIABILITY_NOTE", l: "Poznámka" },

  POINT3_MEDIUM_SEPARATOR: {
    r: "POINT3_MEDIUM_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
    subhead: true,
  },
  POINT3_MEDIUM: {
    r: "POINT3_MEDIUM",
    l: "Provozování rozhlasového nebo televizního vysílání nebo vydávání periodického tisku",
  },
  POINT3_MEDIUM_LEGAL_PERSON_NAME: {
    r: "POINT3_MEDIUM_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název (provozovatele/vydavatele)",
  },
  POINT3_MEDIUM_IDENTIFICATION_NUMBER: {
    r: "POINT3_MEDIUM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_MEDIUM_ADDRESS: {
    r: "POINT3_MEDIUM_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  POINT3_MEDIUM_NAME: { r: "POINT3_MEDIUM_NAME", l: "Název média" },
  POINT3_MEDIUM_NOTE: { r: "POINT3_MEDIUM_NOTE", l: "Poznámka" },

  POINT3_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "POINT3_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Podnikání nebo provozování jiné samostatné výdělečné činnosti",
    subhead: true,
  },
  POINT3_NATURAL_PERSON_BUSINESS: {
    r: "POINT3_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  POINT3_NPB_SUBJECT: { r: "POINT3_NPB_SUBJECT", l: "Předmět" },
  POINT3_NPB_METHOD: { r: "POINT3_NPB_METHOD", l: "Způsob" },
  POINT3_NPB_PLACE: {
    r: "POINT3_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  POINT3_NPB_NOTE: { r: "POINT3_NPB_NOTE", l: "Poznámka" },

  POINT3_OTHER_CONTRACTS_SEPARATOR: {
    r: "POINT3_OTHER_CONTRACTS_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  POINT3_OTHER_CONTRACTS: {
    r: "POINT3_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  POINT3_OC_TYPE: { r: "POINT3_OC_TYPE", l: "Druh činnosti" },
  POINT3_OC_FIRST_NAME: { r: "POINT3_OC_FIRST_NAME", l: "Jméno" },
  POINT3_OC_LAST_NAME: { r: "POINT3_OC_LAST_NAME", l: "Příjmení" },
  POINT3_OC_LEGAL_PERSON_NAME: {
    r: "POINT3_OC_LEGAL_PERSON_NAME",
    l: "Jméno/název",
  },
  POINT3_OC_IDENTIFICATION_NUMBER: {
    r: "POINT3_OC_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_OC_ADDRESS: {
    r: "POINT3_OC_ADDRESS",
    l: "Místo výkonu podnikání/sídlo právnické osoby",
  },
  POINT3_OC_NOTE: { r: "POINT3_OC_NOTE", l: "Poznámka" },
  POINT3_OC_SPECIFICATION: { r: "POINT3_OC_SPECIFICATION", l: "Specifikace" },

  POINT3_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "POINT3_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  POINT3_ORGANIZATION_MEMBER: {
    r: "POINT3_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  POINT3_OM_IDENTIFICATION_NUMBER: {
    r: "POINT3_OM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT3_OM_TYPE: { r: "POINT3_OM_TYPE", l: "Druh orgánu" },
  POINT3_OM_NAME: { r: "POINT3_OM_NAME", l: "Obchodní firma/název" },
  POINT3_OM_ADDRESS: { r: "POINT3_OM_ADDRESS", l: "Sídlo právnické osoby" },
  POINT3_OM_NOTE: { r: "POINT3_OM_NOTE", l: "Poznámka" },

  POINT3_REALTY_SEPARATOR: {
    r: "POINT3_REALTY_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 3 - Věci nemovité",
    subhead: true,
  },
  POINT3_REALTY: { r: "POINT3_REALTY", l: "Věci nemovité" },
  POINT3_REALTY_HASFILEREF: {
    r: "POINT3_REALTY_HASFILEREF",
    l: "Oznámení o nemovitostech bylo podáno formou datového souboru",
  },
  POINT3_REALTY_LV: { r: "POINT3_REALTY_LV", l: "Číslo LV" },
  POINT3_REALTY_CADASTRE: {
    r: "POINT3_REALTY_CADASTRE",
    l: "katastrální území",
  },
  POINT3_REALTY_NOTE: { r: "POINT3_REALTY_NOTE", l: "Poznámka" },
  POINT3_REALTY_TYPE: { r: "POINT3_REALTY_TYPE", l: "Druh nemovité věci" },
  POINT3_REALTY_PARCEL_NUMBER: {
    r: "POINT3_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  POINT3_REALTY_OWNERSHIP: { r: "POINT3_REALTY_OWNERSHIP", l: "Vlastnictví" },
  POINT3_REALTY_ACQUISITION: {
    r: "POINT3_REALTY_ACQUISITION",
    l: "Způsob nabytí",
  },
  POINT3_REALTY_PRICE: { r: "POINT3_REALTY_PRICE", l: "Pořizovací cena" },
  POINT3_REALTY_ORIENTATION_NUMBER: {
    r: "POINT3_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },
  POINT3_REALTY_PUBLICTEMPLATE: {
    r: "POINT3_REALTY_PUBLICTEMPLATE",
    l: "Stáhnout šablonu pro veřejnost",
  },
  POINT3_REALTY_PRIVATETEMPLATE: {
    r: "POINT3_REALTY_PRIVATETEMPLATE",
    l: "Stáhnout šablonu pro správce",
  },
  POINT3_REALTY_PUBLICFILE: {
    r: "POINT3_REALTY_PUBLICFILE",
    l: "Nahrát soubor pro veřejnost",
  },
  POINT3_REALTY_PRIVATEFILE: {
    r: "POINT3_REALTY_PRIVATEFILE",
    l: "Nahrát soubor pro správce",
  },
  POINT3_REALTY_PUBLICDATA: {
    r: "POINT3_REALTY_PUBLICDATA",
    l: "Data pro veřejnost",
  },
  POINT3_REALTY_PRIVATEDATA: {
    r: "POINT3_REALTY_PRIVATEDATA",
    l: "Data pro správce",
  },
};

const helpPoint4Enum = {
  POINT4_INFO: {
    r: "POINT4_INFO",
    l: "Oznámení podle Čl. II bodu 4 - Všeobecné údaje",
    subhead: true,
  },
  POINT4_BIRTH_COUNRTY: { r: "POINT4_BIRTH_COUNRTY", l: "Stát narození" },
  POINT4_BIRTH_MUNICIPALITY: {
    r: "POINT4_BIRTH_MUNICIPALITY",
    l: "Obec narození",
  },

  POINT4_ADDRESS: {
    r: "POINT4_ADDRESS",
    l: "Oznámení podle Čl. II bodu 4 - Adresa pro doručování",
    subhead: true,
  },
  POINT4_EMAIL: { r: "POINT4_EMAIL", l: "E-mail" },

  POINT4_STATEMENT_TYPE_SEPARATOR: {
    r: "POINT4_STATEMENT_TYPE_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 4 - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  POINT4_STATEMENT_TYPE: {
    r: "POINT4_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  POINT4_FROM_DATE: { r: "POINT4_FROM_DATE", l: "Období od" },
  POINT4_TO_DATE: { r: "POINT4_TO_DATE", l: "Období do" },

  POINT4_INCOME_SEPARATOR: {
    r: "POINT4_INCOME_SEPARATOR",
    l: "Oznámení podle Čl. II bodu 4 - Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
    subhead: true,
  },
  POINT4_INCOME: {
    r: "POINT4_INCOME",
    l: "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
  },
  POINT4_INCOME_TYPE: { r: "POINT4_INCOME_TYPE", l: "Druh příjmu" },
  POINT4_INCOME_PRICE: { r: "POINT4_INCOME_PRICE", l: "Výše příjmu" },
  POINT4_INCOME_OTHER: { r: "POINT4_INCOME_OTHER", l: "Zdroj - jiný" },
  POINT4_INCOME_LEGAL_PERSON_NAME: {
    r: "POINT4_INCOME_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  POINT4_INCOME_IDENTIFICATION_NUMBER: {
    r: "POINT4_INCOME_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  POINT4_INCOME_ADDRESS: {
    r: "POINT4_INCOME_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  POINT4_INCOME_NOTE: { r: "POINT4_INCOME_NOTE", l: "Poznámka" },
};

const helpSenatorsEnum = {
  OFFICIAL_INFO: {
    r: "OFFICIAL_INFO",
    l: "Oznámení pro poslance a senátory - Všeobecné údaje",
    subhead: true,
  },
  OFFICIAL_BIRTH_COUNRTY: { r: "OFFICIAL_BIRTH_COUNRTY", l: "Stát narození" },
  OFFICIAL_BIRTH_MUNICIPALITY: {
    r: "OFFICIAL_BIRTH_MUNICIPALITY",
    l: "Obec narození",
  },

  OFFICIAL_ADDRESS: {
    r: "OFFICIAL_ADDRESS",
    l: "Oznámení pro poslance a senátory - Adresa pro doručování",
    subhead: true,
  },
  OFFICIAL_EMAIL: { r: "OFFICIAL_EMAIL", l: "E-mail" },

  OFFICIAL_STATEMENT_TYPE_SEPARATOR: {
    r: "OFFICIAL_STATEMENT_TYPE_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Druh oznámení a období, za které oznámení podává",
    subhead: true,
  },
  OFFICIAL_STATEMENT_TYPE: {
    r: "OFFICIAL_STATEMENT_TYPE",
    l: "Druh oznámení a období, za které oznámení podává",
  },
  OFFICIAL_FROM_DATE: { r: "OFFICIAL_FROM_DATE", l: "Období od" },
  OFFICIAL_TO_DATE: { r: "OFFICIAL_TO_DATE", l: "Období do" },

  OFFICIAL_NATURAL_PERSON_BUSINESS_SEPARATOR: {
    r: "OFFICIAL_NATURAL_PERSON_BUSINESS_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Podnikání nebo provozování jiné samostatné výdělečné činnosti",
    subhead: true,
  },
  OFFICIAL_NATURAL_PERSON_BUSINESS: {
    r: "OFFICIAL_NATURAL_PERSON_BUSINESS",
    l: "Podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  OFFICIAL_NPB_SUBJECT: { r: "OFFICIAL_NPB_SUBJECT", l: "Předmět" },
  OFFICIAL_NPB_METHOD: { r: "OFFICIAL_NPB_METHOD", l: "Způsob" },
  OFFICIAL_NPB_PLACE: {
    r: "OFFICIAL_NPB_PLACE",
    l: "Místo výkonu podnikání nebo provozování jiné samostatné výdělečné činnosti",
  },
  OFFICIAL_NPB_NOTE: { r: "OFFICIAL_NPB_NOTE", l: "Poznámka" },

  OFFICIAL_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR: {
    r: "OFFICIAL_LEGAL_BUSINESS_ASSOCIATES_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Společník nebo člen podnikající právnické osoby",
    subhead: true,
  },
  OFFICIAL_LEGAL_BUSINESS_ASSOCIATES: {
    r: "OFFICIAL_LEGAL_BUSINESS_ASSOCIATES",
    l: "Společník nebo člen podnikající právnické osoby",
  },
  OFFICIAL_LBA_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_LBA_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_LBA_NAME: { r: "OFFICIAL_LBA_NAME", l: "Obchodní firma/název" },
  OFFICIAL_LBA_ADDRESS: {
    r: "OFFICIAL_LBA_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  OFFICIAL_LBA_NOTE: { r: "OFFICIAL_LBA_NOTE", l: "Poznámka" },

  OFFICIAL_ORGANIZATION_MEMBER_SEPARATOR: {
    r: "OFFICIAL_ORGANIZATION_MEMBER_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
    subhead: true,
  },
  OFFICIAL_ORGANIZATION_MEMBER: {
    r: "OFFICIAL_ORGANIZATION_MEMBER",
    l: "Člen statutárního orgánu, člen řídícího, dozorčího nebo kontrolního orgánu podnikající právnické osoby",
  },
  OFFICIAL_OM_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_OM_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_OM_TYPE: { r: "OFFICIAL_OM_TYPE", l: "Druh orgánu" },
  OFFICIAL_OM_NAME: { r: "OFFICIAL_OM_NAME", l: "Obchodní firma/název" },
  OFFICIAL_OM_ADDRESS: { r: "OFFICIAL_OM_ADDRESS", l: "Sídlo právnické osoby" },
  OFFICIAL_OM_NOTE: { r: "OFFICIAL_OM_NOTE", l: "Poznámka" },

  OFFICIAL_OTHER_CONTRACTS_SEPARATOR: {
    r: "OFFICIAL_OTHER_CONTRACTS_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
    subhead: true,
  },
  OFFICIAL_OTHER_CONTRACTS: {
    r: "OFFICIAL_OTHER_CONTRACTS",
    l: "Další činnost v pracovněprávním nebo obdobném vztahu nebo ve služebním poměru, nejde-li o vztah nebo poměr, v němž působí jako veřejný funkcionář",
  },
  OFFICIAL_OC_TYPE: { r: "OFFICIAL_OC_TYPE", l: "Druh činnosti" },
  OFFICIAL_OC_LEGAL_PERSON_NAME: {
    r: "OFFICIAL_OC_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OFFICIAL_OC_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_OC_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_OC_ADDRESS: { r: "OFFICIAL_OC_ADDRESS", l: "Sídlo právnické osoby" },
  OFFICIAL_OC_NOTE: { r: "OFFICIAL_OC_NOTE", l: "Poznámka" },

  OFFICIAL_REALTY_SEPARATOR: {
    r: "OFFICIAL_REALTY_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Věci nemovité",
    subhead: true,
  },
  OFFICIAL_REALTY: { r: "OFFICIAL_REALTY", l: "Věci nemovité" },
  OFFICIAL_REALTY_HASFILEREF: {
    r: "OFFICIAL_REALTY_HASFILEREF",
    l: "Oznámení o nemovitostech bylo podáno formou datového souboru",
  },
  OFFICIAL_REALTY_LV: { r: "OFFICIAL_REALTY_LV", l: "Číslo LV" },
  OFFICIAL_REALTY_CADASTRE: {
    r: "OFFICIAL_REALTY_CADASTRE",
    l: "katastrální území",
  },
  OFFICIAL_REALTY_NOTE: { r: "OFFICIAL_REALTY_NOTE", l: "Poznámka" },
  OFFICIAL_REALTY_TYPE: { r: "OFFICIAL_REALTY_TYPE", l: "Druh nemovité věci" },
  OFFICIAL_REALTY_PARCEL_NUMBER: {
    r: "OFFICIAL_REALTY_PARCEL_NUMBER",
    l: "Parcelní číslo",
  },
  OFFICIAL_REALTY_OWNERSHIP: {
    r: "OFFICIAL_REALTY_OWNERSHIP",
    l: "Vlastnictví",
  },
  OFFICIAL_REALTY_ACQUISITION: {
    r: "OFFICIAL_REALTY_ACQUISITION",
    l: "Způsob nabytí",
  },
  OFFICIAL_REALTY_PRICE: { r: "OFFICIAL_REALTY_PRICE", l: "Pořizovací cena" },
  OFFICIAL_REALTY_ORIENTATION_NUMBER: {
    r: "OFFICIAL_REALTY_ORIENTATION_NUMBER",
    l: "Číslo popisné/evidenční",
  },
  OFFICIAL_REALTY_PUBLICTEMPLATE: {
    r: "OFFICIAL_REALTY_PUBLICTEMPLATE",
    l: "Stáhnout šablonu pro veřejnost",
  },
  OFFICIAL_REALTY_PRIVATETEMPLATE: {
    r: "OFFICIAL_REALTY_PRIVATETEMPLATE",
    l: "Stáhnout šablonu pro správce",
  },
  OFFICIAL_REALTY_PUBLICFILE: {
    r: "OFFICIAL_REALTY_PUBLICFILE",
    l: "Nahrát soubor pro veřejnost",
  },
  OFFICIAL_REALTY_PRIVATEFILE: {
    r: "OFFICIAL_REALTY_PRIVATEFILE",
    l: "Nahrát soubor pro správce",
  },
  OFFICIAL_REALTY_PUBLICDATA: {
    r: "OFFICIAL_REALTY_PUBLICDATA",
    l: "Data pro veřejnost",
  },
  OFFICIAL_REALTY_PRIVATEDATA: {
    r: "OFFICIAL_REALTY_PRIVATEDATA",
    l: "Data pro správce",
  },

  OFFICIAL_COMMERCIAL_PAPERS_SEPARATOR: {
    r: "OFFICIAL_COMMERCIAL_PAPERS_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená...",
    subhead: true,
  },
  OFFICIAL_COMMERCIAL_PAPERS: {
    r: "OFFICIAL_COMMERCIAL_PAPERS",
    l: "Cenné papíry, zaknihované cenné papíry nebo práva s nimi spojená, pokud celková výše kupní ceny cenných papírů, zaknihovaných cenných papírů nebo práv s nimi spojených od jednoho emitenta v době nabytí přesahuje částku 50 000,- Kč anebo částku 100 000,- Kč v případě více emitentů",
  },
  OFFICIAL_CP_TYPE: { r: "OFFICIAL_CP_TYPE", l: "Druh " },
  OFFICIAL_CP_ISSUER: { r: "OFFICIAL_CP_ISSUER", l: "Emitent" },
  OFFICIAL_CP_PRICE: { r: "OFFICIAL_CP_PRICE", l: "Pořizovací cena" },
  OFFICIAL_CP_NOTE: { r: "OFFICIAL_CP_NOTE", l: "Poznámka" },

  OFFICIAL_CORPORATION_SHARE_SEPARATOR: {
    r: "OFFICIAL_CORPORATION_SHARE_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem...",
    subhead: true,
  },
  OFFICIAL_CORPORATION_SHARE: {
    r: "OFFICIAL_CORPORATION_SHARE",
    l: "Podíl v obchodní korporaci nepředstavovaný cenným papírem nebo zaknihovaným cenným papírem, pokud hodnota tohoto podílu přesahuje částku 50 000,- Kč anebo částku 100 00,- Kč, jde-li o podíly u více obchodních korporací",
  },
  OFFICIAL_CS_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_CS_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_CS_NAME: {
    r: "OFFICIAL_CS_NAME",
    l: "Obchodní firma/název obchodní korporace",
  },
  OFFICIAL_CS_PRICE: { r: "OFFICIAL_CS_PRICE", l: "Hodnota obchodního podílu" },
  OFFICIAL_CS_ADDRESS: {
    r: "OFFICIAL_CS_ADDRESS",
    l: "Sídlo obchodní korporace",
  },
  OFFICIAL_CS_NOTE: { r: "OFFICIAL_CS_NOTE", l: "Poznámka" },

  OFFICIAL_CHATTEL_SEPARATOR: {
    r: "OFFICIAL_CHATTEL_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Věci movité nabyté v průběhu kalendářního roku...",
    subhead: true,
  },
  OFFICIAL_CHATTEL: {
    r: "OFFICIAL_CHATTEL",
    l: "Věci movité nabyté v průběhu kalendářního roku, jejichž hodnota ve svém souhrnu, do něhož se nezapočítávají věci, jejichž cena je nižší než 25 000,- Kč, přesáhla částku 500 000,- Kč",
  },
  OFFICIAL_CHATTEL_TYPE: { r: "OFFICIAL_CHATTEL_TYPE", l: "Druh movité věci" },
  OFFICIAL_CHATTEL_PRICE: { r: "OFFICIAL_CHATTEL_PRICE", l: "Pořizovací cena" },
  OFFICIAL_CHATTEL_ACQUISITION: {
    r: "OFFICIAL_CHATTEL_ACQUISITION",
    l: "Způsob nabytí",
  },
  OFFICIAL_CHATTEL_NOTE: { r: "OFFICIAL_CHATTEL_NOTE", l: "Poznámka" },

  OFFICIAL_INCOME_SEPARATOR: {
    r: "OFFICIAL_INCOME_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
    subhead: true,
  },
  OFFICIAL_INCOME: {
    r: "OFFICIAL_INCOME",
    l: "Jakékoliv peněžité příjmy nebo jiné majetkové výhody a dary, pokud jejich souhrnná výše přesáhne v kalendářním roce částku 100 000,- Kč",
  },
  OFFICIAL_INCOME_TYPE: { r: "OFFICIAL_INCOME_TYPE", l: "Druh příjmu" },
  OFFICIAL_INCOME_PRICE: { r: "OFFICIAL_INCOME_PRICE", l: "Výše příjmu" },
  OFFICIAL_INCOME_OTHER: { r: "OFFICIAL_INCOME_OTHER", l: "Zdroj - jiný" },
  OFFICIAL_INCOME_LEGAL_PERSON_NAME: {
    r: "OFFICIAL_INCOME_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OFFICIAL_INCOME_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_INCOME_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_INCOME_ADDRESS: {
    r: "OFFICIAL_INCOME_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  OFFICIAL_INCOME_NOTE: { r: "OFFICIAL_INCOME_NOTE", l: "Poznámka" },
  OFFICIAL_INCOME_PSC: { r: "OFFICIAL_INCOME_PSC", l: "PSČ" },

  OFFICIAL_LIABILITY_SEPARATOR: {
    r: "OFFICIAL_LIABILITY_SEPARATOR",
    l: "Oznámení pro poslance a senátory - Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše přesáhla ke dni 1. září kalendářního roku částku 100 000,- Kč",
    subhead: true,
  },
  OFFICIAL_LIABILITY: {
    r: "OFFICIAL_LIABILITY",
    l: "Nesplacené závazky, zejména půjčky a úvěry, pokud jejich souhrnná výše přesáhla ke dni 1. září kalendářního roku částku 100 000,- Kč",
  },
  OFFICIAL_LIABILITY_TYPE: { r: "OFFICIAL_LIABILITY_TYPE", l: "Druh závazku" },
  OFFICIAL_LIABILITY_PRICE: {
    r: "OFFICIAL_LIABILITY_PRICE",
    l: "Výše závazku",
  },
  OFFICIAL_LIABILITY_LEGAL_PERSON_NAME: {
    r: "OFFICIAL_LIABILITY_LEGAL_PERSON_NAME",
    l: "Obchodní firma/název",
  },
  OFFICIAL_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER: {
    r: "OFFICIAL_LIABILITY_LEGAL_PERSON_IDENTIFICATION_NUMBER",
    l: "IČO",
  },
  OFFICIAL_LIABILITY_LEGAL_PERSON_ADDRESS: {
    r: "OFFICIAL_LIABILITY_LEGAL_PERSON_ADDRESS",
    l: "Sídlo právnické osoby",
  },
  OFFICIAL_LIABILITY_NOTE: { r: "OFFICIAL_LIABILITY_NOTE", l: "Poznámka" },
};

export const getInitPlacements = (data, set) => {
  return Object.keys(set).map((key) => {
    const placement = set[key].r;
    return (
      data[placement] || { placement, text: "", subhead: set[key].subhead }
    );
  });
};

export const enumOnCondition = (condition) => (help) =>
  condition ? help : undefined;

export {
  helpCategoriesEnum,
  helpGeneralEnum,
  helpInEnum,
  helpOnEnum,
  helpOutEnum,
  helpOvmEnum,
  helpPoint3Enum,
  helpRequestInitiativeEnum,
  helpPoint4Enum,
  helpSenatorsEnum,
};

const safeHelpEnum = new Proxy(Enum, {
  get(target, prop) {
    if (typeof prop === "string" && !(prop in target)) {
      return { r: undefined, l: "" }; // Fallback for missing keys
    }
    return target[prop];
  },
});

export default safeHelpEnum;
